/**
 * Spanish catalog — under_construction / preview only until published.
 * Missing keys fall back to English.
 */

import type { MessageCatalog } from './en';

export const esCatalog: MessageCatalog = {
  'ui.READ_GREEN_BOOK': 'Leer el Libro Verde',
  'ui.READ_GUIDANCE': 'Leer la guía',
  'ui.WATCH_VIDEO': 'Ver video',
  'ui.SHARE_WITH_SPONSOR': 'Compartir con el padrino',
  'ui.FIRST_STEP_WRITING_WORKSPACE': 'Espacio de escritura del Primer Paso',
  'ui.OPEN_AMENDS_LIST': 'Abrir lista de enmiendas',
  'ui.PRACTICE_INVENTORY': 'Practicar inventario',
  'ui.ENTER_UPDATE_3_CIRCLES': 'Ingresar/actualizar mis 3 círculos',
  'ui.SHARE_ACTION_TITLE': 'Compartir y revisar tu trabajo con tu padrino',
  'ui.SHARE_DEFECTS_ACTION_TITLE': 'Compartir y revisar mis defectos de carácter con mi padrino',
  'ui.DEFAULT_SHARE_EMPTY_MESSAGE':
    'Completa al menos una acción o agrega algo de trabajo en este paso antes de compartir.',
  'ui.COMPLETED': 'Completado',
  'ui.EXPAND': 'Expandir',
  'ui.COLLAPSE': 'Contraer',

  'nav.home': 'Inicio',
  'nav.saa': 'SAA',
  'nav.12_steps': '12 Pasos',

  'stepName.1': 'Uno',
  'stepName.2': 'Dos',
  'stepName.3': 'Tres',
  'stepName.4': 'Cuatro',
  'stepName.5': 'Cinco',
  'stepName.6': 'Seis',
  'stepName.7': 'Siete',
  'stepName.8': 'Ocho',
  'stepName.9': 'Nueve',
  'stepName.10': 'Diez',
  'stepName.11': 'Once',
  'stepName.12': 'Doce',

  'step.page.title': 'Paso {stepName}',
  'step.page.actions_title': 'Acciones para completar el Paso {stepName}',
  'step.page.actions_intro':
    'Completa cada acción en orden. Marca la casilla cuando hayas terminado cada acción.',

  'getting_started.page.title': 'Primeros pasos',
  'getting_started.page.subtitle':
    'Comprender mi adicción y definir qué significa actuar compulsivamente para mí — antes de comenzar el Paso Uno.',
  'getting_started.page.actions_title': 'Acciones para completar Primeros pasos',

  'step.action.template.how_to_work.title': 'Cómo trabajar el Paso {stepName} (guía y video)',
  'step.action.template.read_guidance.title': 'Leer la guía para trabajar el Paso {stepName}',
  'step.action.template.read_green_book.title': 'Leer el Libro Verde de SAA sobre el Paso {stepName}',
  'step.action.template.understand_step.title':
    'Entender de qué se trata el Paso {stepName} en SAA y por qué es importante',
  'step.action.template.guidance_and_video.description':
    'Lee la guía y mira el video sobre cómo trabajar el Paso {stepName}',
  'step.action.template.practical_guidance.description':
    'Lee la guía práctica sobre cómo trabajar el Paso {stepName} de manera efectiva.',
  'step.action.template.review_with_sponsor.description':
    'Revisa tu trabajo del Paso {stepName} con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',

  'i18n.offer.title': 'Preferencia de idioma',
  'i18n.offer.body': 'Parece que prefieres {language}. ¿Quieres usarlo en Recovery Commons?',
  'i18n.offer.accept': 'Usar {language}',
  'i18n.offer.decline': 'Seguir en inglés',
  'i18n.auto.body': 'Te mostramos Recovery Commons en español porque tu navegador está configurado en español.',
  'i18n.auto.keep': 'Continuar en español',
  'i18n.switcher.label': 'Idioma',
  'i18n.switcher.aria': 'Elegir idioma',
  'i18n.switcher.preview': 'vista previa',

  'getting_started.action.1.title': 'Leer sobre nuestra adicción',
  'getting_started.action.2.title': 'Leer sobre nuestra confraternidad',
  'getting_started.action.3.title': 'Mi padrino',
  'getting_started.action.4.title': 'Leer sobre los 3 Círculos',
  'getting_started.action.5.title': 'Ver: Los 3 Círculos de SAA',
  'getting_started.action.6.title': 'Definir mis 3 Círculos',
  'getting_started.action.8.title': 'Listo para el Paso Uno',

  'getting_started.action.1.description': 'Introducción y Nuestra Adicción del Libro Verde',
  'getting_started.action.2.description': 'Reuniones y padrinazgo del Libro Verde',
  'getting_started.action.3.description':
    'Para trabajar los pasos de manera efectiva, necesito tener un padrino. ¿Dónde estás en ese proceso?',
  'getting_started.action.4.description':
    'Cómo los miembros de SAA definen la abstinencia usando la herramienta de los Tres Círculos',
  'getting_started.action.5.description': 'Video que profundiza en esta valiosa herramienta',
  'getting_started.action.6.description':
    'Ingresar/actualizar mis 3 círculos personales: interior (actuar compulsivamente), medio (señales de alerta) y exterior (apoya la recuperación). Sé que pueden cambiar a lo largo de la recuperación y que solo haré cambios después de hablar con mi padrino y otras personas del programa.',
  'getting_started.action.7.description':
    'Revisa tu progreso de Primeros pasos y tus 3 Círculos con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',
  'getting_started.action.8.description':
    'Has completado el trabajo introductorio y estás listo para comenzar el Paso Uno.',

  'getting_started.sponsor.have_sponsor': 'Tengo un padrino',
  'getting_started.sponsor.looking': 'Estoy buscando un padrino',
  'getting_started.sponsor.ask_in_meeting': 'Le pediré a alguien en una reunión',
  'getting_started.sponsor.open_profile_cta': 'Abrir Perfil → Padrinazgo',
  'getting_started.sponsor.added_one':
    'Has agregado el nombre y el correo de tu padrino en tu perfil.',
  'getting_started.sponsor.added_many':
    'Has agregado los nombres y los correos de tus padrinos en tu perfil.',

  'getting_started.circles.modal_title': 'Mis 3 Círculos',
  'getting_started.circles.close': 'Cerrar',
  'getting_started.circles.login_prompt':
    'Inicia sesión para crear y administrar tus 3 Círculos.',
  'getting_started.circles.intro':
    'Define tus 3 Círculos personales. Interior = actuar compulsivamente para ti. Medio = señales de alerta. Exterior = lo que apoya tu recuperación. Conversarlos con tu padrino cuando puedas.',
  'getting_started.circles.inner.title': 'Círculo interior',
  'getting_started.circles.inner.subtitle': 'Conductas que identifico como actuar compulsivamente',
  'getting_started.circles.inner.placeholder': 'Agregar una conducta',
  'getting_started.circles.inner.name': 'interior',
  'getting_started.circles.middle.title': 'Círculo medio',
  'getting_started.circles.middle.subtitle': 'Pendiente resbaladiza — señales de alerta',
  'getting_started.circles.middle.placeholder': 'Agregar una señal de alerta',
  'getting_started.circles.middle.name': 'medio',
  'getting_started.circles.outer.title': 'Círculo exterior',
  'getting_started.circles.outer.subtitle': 'Saludable — apoya mi recuperación',
  'getting_started.circles.outer.placeholder': 'Agregar una conducta saludable',
  'getting_started.circles.outer.name': 'exterior',
  'getting_started.circles.add_to_list': 'Agregar a la lista',
  'getting_started.circles.remove': 'Quitar',
  'getting_started.circles.remove_confirm': '¿Quitar «{item}» de tu círculo {circle}?',
  'getting_started.circles.saving': 'Guardando…',
  'getting_started.circles.unsaved': 'Cambios sin guardar',
  'getting_started.circles.saved_encrypted': 'Guardado · cifrado',
  'getting_started.circles.last_saved': ' · Guardado por última vez a las {time}',
  'getting_started.circles.preview.inner':
    'Círculo interior — conductas que identifico como actuar compulsivamente',
  'getting_started.circles.preview.middle': 'Medio — señales de alerta',
  'getting_started.circles.preview.outer': 'Exterior — apoya la recuperación',

  'getting_started.video.title': 'Los 3 Círculos de SAA',
  'getting_started.share.empty_message':
    'Completa al menos una acción o agrega algo a tus 3 Círculos antes de compartir.',

  'step.1.action.3.title': 'Preparar mi historia del Primer Paso',
  'step.1.action.4.title': 'Hablar con mi padrino sobre mi Primer Paso',
  'step.1.action.5.title': 'Leer mi Primer Paso en una reunión',
  'step.1.action.6.title':
    'Tomar el Paso Uno: Admitir que soy impotente ante la adicción sexual compulsiva — que mi vida se ha vuelto ingobernable',
  'step.2.action.3.title': 'Responder las preguntas del Paso Dos',
  'step.2.action.5.title': 'Tomar el Paso Dos: Declarar disposición',
  'step.3.action.3.title': 'Responder las preguntas del Paso Tres',
  'step.3.action.4.title': 'Leer la Oración del Tercer Paso — y escribir la mía si lo elijo',
  'step.3.action.6.title': 'Tomar el Paso Tres',
  'step.4.action.3.title': 'Completar inventarios y programar el Paso Cinco',
  'step.4.action.5.title':
    'Tomar el Paso Cuatro: He hecho un inventario moral profundo y valiente de mí mismo',
  'step.5.action.3.title': 'Presentar mis inventarios del Paso Cuatro a mi padrino',
  'step.5.action.4.title': 'Identificar mis defectos de carácter',
  'step.5.action.6.title': 'Tomar el Paso Cinco',
  'step.6.action.3.title': 'Trabajar los defectos de carácter',
  'step.6.action.5.title':
    'Tomar el Paso Seis: Estuvimos enteramente dispuestos a que Dios removiera todos estos defectos de carácter',
  'step.7.action.3.title': 'Leer la Oración del Séptimo Paso — y escribir la mía si lo elijo',
  'step.7.action.5.title': 'Tomar el Paso Siete: leer en voz alta la Oración del Séptimo Paso',
  'step.8.action.3.title': 'Tomar el Paso Ocho: Hacer una lista de las personas a quienes he dañado',
  'step.8.action.5.title':
    'Tomar el Paso Ocho: Hicimos una lista de todas las personas que habíamos dañado, y estuvimos dispuestos a enmendarlo todo con ellas',
  'step.9.action.3.title':
    'Tomar el Paso Nueve: Hacer enmiendas directas a tales personas siempre que sea posible',
  'step.9.action.5.title':
    'Tomar el Paso Nueve: Hicimos enmiendas directas a tales personas siempre que nos fue posible, excepto cuando el hacerlo les habría injuriado a ellas o a otros',
  'step.10.action.3.title':
    'Tomar el Paso Diez: Continuar haciendo inventario personal y admitir de inmediato cuando estoy equivocado',
  'step.10.action.5.title':
    'Tomar el Paso Diez: Continuamos haciendo el inventario personal y cuando nos equivocábamos lo admitíamos de inmediato',
  'step.11.action.3.title': 'Definir mi plan diario de tiempo en quietud y practicarlo',
  'step.11.action.5.title': 'Tomar el Paso Once',
  'step.12.action.3.title': 'Definir mi plan de servicio',
  'step.12.action.5.title': 'Tomar el Paso Doce',

  'step.1.quote':
    'Admitimos que éramos impotentes ante la conducta sexual compulsiva, que nuestras vidas se habían vuelto ingobernables.',
  'step.2.quote':
    'Llegamos a creer que un Poder superior a nosotros mismos podía devolvernos el sano juicio.',
  'step.3.quote':
    'Decidimos poner nuestras voluntades y nuestras vidas al cuidado de Dios, como nosotros lo concebimos.',
  'step.4.quote': 'Sin miedo hicimos un minucioso inventario moral de nosotros mismos.',
  'step.5.quote':
    'Admitimos ante Dios, ante nosotros mismos y ante otro ser humano la naturaleza exacta de nuestros defectos.',
  'step.6.quote':
    'Estuvimos enteramente dispuestos a que Dios removiera todos estos defectos de carácter.',
  'step.7.quote': 'Humildemente le pedimos que nos liberara de nuestros defectos.',
  'step.8.quote':
    'Hicimos una lista de todas las personas que habíamos dañado, y estuvimos dispuestos a enmendarlo todo con ellas.',
  'step.9.quote':
    'Hicimos enmiendas directas a tales personas siempre que nos fue posible, excepto cuando el hacerlo les habría injuriado a ellas o a otros.',
  'step.10.quote':
    'Continuamos haciendo el inventario personal y cuando nos equivocábamos lo admitíamos de inmediato.',
  'step.11.quote':
    'Buscamos a través de la oración y la meditación mejorar nuestro contacto consciente con Dios, como nosotros lo concebimos, pidiéndole solamente que nos dejara conocer su voluntad para con nosotros y nos diera la fortaleza para cumplirla.',
  'step.12.quote':
    'Habiendo obtenido un despertar espiritual como resultado de estos pasos, tratamos de llevar este mensaje a los adictos sexuales y de practicar estos principios en todos nuestros asuntos.',

  'step.1.action.1.description':
    'Comprender cómo mi conducta adictiva hizo ingobernable mi vida y por qué importa la rendición',
  'step.1.action.3.description':
    'Redacta o actualiza tu Primer Paso en el espacio de escritura. Ve, descarga o comparte tu historia cuando estés listo.',
  'step.1.action.4.description':
    'Es importante que revise mi Primer Paso con un padrino u otra persona de confianza antes de presentarlo.',
  'step.1.action.5.description': 'Comparte tu trabajo del Paso Uno en una reunión de SAA',
  'step.1.action.6.description': 'Hacer la admisión final que completa el Paso Uno',

  'step.2.action.1.description':
    'Descubrir cómo la fe en un poder superior a mí mismo devolvió el sano juicio a otros — y cómo puede hacerlo por mí',
  'step.2.action.3.description':
    'Reflexiona con honestidad sobre la espiritualidad, el poder superior y experiencias relacionadas — no hay una respuesta correcta, solo tu historia.',
  'step.2.action.5.description':
    'Estoy dispuesto a creer que un poder superior a mí mismo puede devolverme el sano juicio',

  'step.3.action.1.description':
    'Aprender cómo entregar la vida y la voluntad al cuidado espiritual abre la puerta a mi transformación',
  'step.3.action.3.description':
    'Reflexiona sobre la propia voluntad, entregar tu vida y tu poder superior — no hay respuesta correcta, solo respuestas honestas.',
  'step.3.action.4.description':
    'Lee la Oración tradicional del Tercer Paso abajo. Escribir tu propia versión es opcional — muchos miembros lo hacen.',
  'step.3.action.5.description':
    'Comparte tus preguntas del Paso Tres y tu oración (si escribiste la tuya) con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',
  'step.3.action.6.description':
    'He tomado la decisión de poner mi voluntad y mi vida al cuidado de Dios como yo lo concibo.',

  'step.4.action.1.description':
    'Aprender cómo escribir inventarios morales valientes me ayuda a descubrir cómo las creencias y sentimientos impulsan mi conducta',
  'step.4.action.3.description':
    'Enfrentar mis resentimientos, temores y daños es como comienza la verdadera sanación.',
  'step.4.action.5.description': 'Completar el paso reconociendo tu trabajo de inventario',

  'step.5.action.1.description':
    'Descubrir por qué revelar la naturaleza exacta de mis errores trae alivio y claridad',
  'step.5.action.3.description':
    'Siéntate con tu padrino en persona o en línea y revisa tus inventarios en voz alta — entrada por entrada. Tu padrino escucha, anima y puede tomar notas. Algunos miembros necesitan varias reuniones para terminar. Tú y tu padrino pueden trabajar esta y las siguientes 2 acciones de este paso en el orden que mejor se adapte. Márcalo cuando hayas terminado de presentar tus inventarios (o cuando estés conforme con dónde estás por ahora).',
  'step.5.action.4.description':
    'Con la ayuda de tu padrino, nombra los defectos de carácter que aparecieron en tu inventario. Puedes notar muchos, pero la mayoría de los miembros se enfocan en sus 3–6 más impactantes en este recorrido de los pasos. Ingresa tu lista inicial aquí — trabajaremos más en ellos en los Pasos Seis y Siete.',
  'step.5.action.5.description':
    'Si tú y tu padrino aún no han acordado los defectos de carácter en los que trabajarán esta vez, actualiza a tu padrino sobre tu lista. Márcalo cuando lo hayan conversado — el botón de compartir es opcional para un resumen escrito.',
  'step.5.action.6.description':
    'Admití ante Dios, ante mí mismo y ante otro ser humano la naturaleza exacta de mis defectos.',

  'step.6.action.1.description':
    'Comprender qué significa realmente la «entera disposición» — y cómo me prepara profundamente para el cambio',
  'step.6.action.3.description':
    'Responder preguntas sobre cada defecto de carácter para estar dispuesto a soltarlos',
  'step.6.action.5.description':
    'Completar el Paso Seis reconociendo tu disposición a soltar los defectos de carácter',

  'step.7.action.1.description':
    'Explorar cómo la oración humilde puede abrir el camino para liberarme de mis defectos e invitar la libertad espiritual',
  'step.7.action.3.description':
    'Lee la Oración tradicional del Séptimo Paso abajo. Escribir tu propia versión es opcional — muchos miembros lo hacen.',
  'step.7.action.4.description':
    'Comparte tu Oración del Séptimo Paso (si escribiste la tuya) con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',
  'step.7.action.5.description':
    'Pide con humildad a tu Poder Superior que te liberara de tus defectos leyendo en voz alta la Oración del Séptimo Paso — con tus propias palabras o la versión tradicional — y vuelve a ella con regularidad.',

  'step.8.action.1.description':
    'Aprender por qué nombrar a quienes he dañado y cultivar la disposición son críticos antes de hacer enmiendas',
  'step.8.action.3.description': 'Crear una lista de personas a quienes has dañado con tus acciones',
  'step.8.action.5.description': 'Completar el Paso Ocho reconociendo tu trabajo en la lista de enmiendas',

  'step.9.action.1.description':
    'Entender cómo hacer enmiendas de formas que sanen — sin causar nuevo daño',
  'step.9.action.3.description':
    'Hacer enmiendas a las personas que has dañado, excepto cuando el hacerlo les injuriaría a ellas o a otros',
  'step.9.action.5.description': 'Completar el Paso Nueve reconociendo tu trabajo de enmiendas',

  'step.10.action.1.description':
    'Descubrir cómo el inventario personal diario y admitir de inmediato sostienen la claridad y la conexión en mi recuperación',
  'step.10.action.3.description':
    'Practicar el autoexamen continuo y admitir los errores de inmediato',
  'step.10.action.5.description': 'Completar el Paso Diez reconociendo tu práctica de inventario',

  'step.11.action.1.description':
    'Aprender cómo la oración y la meditación profundizan mi contacto consciente y guían una acción significativa',
  'step.11.action.3.description':
    'Escribe tu plan de oración y meditación, luego practícalo en tu rutina diaria.',
  'step.11.action.4.description':
    'Comparte tu plan de tiempo en quietud con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',
  'step.11.action.5.description':
    'Buscamos a través de la oración y la meditación mejorar nuestro contacto consciente con Dios, como nosotros lo concebimos, pidiéndole solamente que nos dejara conocer su voluntad para con nosotros y nos diera la fortaleza para cumplirla.',

  'step.12.action.1.description':
    'Ver cómo el despertar espiritual me lleva naturalmente a llevar el mensaje y vivir la recuperación en todas las áreas de la vida',
  'step.12.action.3.description':
    'Escribe cómo quieres llevar el mensaje y practicar estos principios en tu vida diaria.',
  'step.12.action.4.description':
    'Comparte tu plan de servicio con tu padrino. Puedes marcar esto cuando hayas compartido o conversado tu trabajo — usar el botón de compartir es opcional.',
  'step.12.action.5.description':
    'Habiendo obtenido un despertar espiritual como resultado de estos pasos, tratamos de llevar este mensaje a los adictos sexuales y de practicar estos principios en todos nuestros asuntos.',

  'ui.REFRESH_PAGE': 'Actualizar página',
  'step.page.loading': 'Cargando tu progreso...',
  'step.page.congrats_heading': '🎉 ¡Felicidades!',
  'step.page.congrats_body':
    'Has completado todas las acciones del Paso {stepName} y puedes continuar con el Paso {nextStepName}.',
  'step.page.prev_link': '<< Paso {stepName}',
  'step.page.next_link': 'Paso {stepName} >>',
  'step.page.prev_getting_started': '<< Primeros pasos',
  'step.page.guidance_title': 'Guía para trabajar el Paso {stepName}',
  'step.page.video_title': 'Video guía del Paso {stepName}',

  'getting_started.page.congrats_body':
    'Has completado Primeros pasos y puedes comenzar el Paso Uno.',
  'getting_started.page.next_link': 'Paso Uno >>',
  'getting_started.page.congrats_heading': '¡Felicidades!',

  'step.12.congrats_body':
    '🎉 ¡Felicidades! Has completado los 12 Pasos de SAA. Ahora estás listo para continuar tu camino de recuperación y ayudar a otros.',

  'step.8.helper.empty':
    'Aún no has agregado personas. Haz clic en «Abrir lista de enmiendas» para comenzar.',
  'step.8.helper.count':
    '{count} {personWord} en tu lista ({completed} completado(s)).',
  'step.8.helper.person': 'persona',
  'step.8.helper.persons': 'personas',
  'step.8.helper.requires_action3':
    'La acción 4 requiere que la acción 3 esté completada primero.',

  'step.9.helper.copy_from_step8':
    'Puedes copiar tu lista del Paso 8. Haz clic en «Abrir lista de enmiendas» para abrir el diálogo y luego usa el botón «Copiar del Paso Ocho» para traer tu lista del Paso 8. Después puedes agregar tu plan de enmiendas y dar seguimiento a tu progreso.',
  'step.9.helper.count':
    '{count} {personWord} en tu lista de enmiendas ({planned} planificado(s), {completed} completado(s)).',

  'step.10.helper.empty':
    'Practica un inventario nocturno cuando estés listo. Haz clic en «Practicar inventario» para agregar entradas — o marca esta acción en cualquier momento; no hay un mínimo de entradas.',
  'step.10.helper.count_complete': '{count} {entryWord} completa(s)',
  'step.10.helper.count_incomplete': '({count} incompleta(s)).',
  'step.10.helper.entry': 'entrada',
  'step.10.helper.entries': 'entradas',

  'step.question.placeholder_default': 'Empieza a escribir tu respuesta aquí...',
  'step.question.help_button_title': 'Obtener ayuda con esta pregunta',
  'step.question.help_dialog_title': 'Ayuda',
  'step.question.help_not_found': 'No se encontró contenido de ayuda para esta pregunta.',
  'step.question.help_error': 'Error al cargar el contenido de ayuda.',
  'step.workspace.saving': 'Guardando...',
  'step.workspace.saved': '✓ Guardado',
  'step.workspace.saved_all': '✓ Todos los cambios guardados',
  'step.workspace.save_failed': '⚠ No se pudo guardar. Inténtalo de nuevo.',
  'step.workspace.save_answers_error': 'No se pudieron guardar las respuestas. Inténtalo de nuevo.',
  'step.workspace.save_prayer_error': 'No se pudo guardar la oración. Inténtalo de nuevo.',

  'step.2.question.q1.label':
    'Describe cómo era la espiritualidad / religión para ti mientras crecías, su impacto en ti y cualquier sentimiento que tengas al respecto.',
  'step.2.question.q1.placeholder':
    'p. ej., En mi familia, la religión era estricta y daba miedo. Me hacía sentir desconectado...',
  'step.2.question.q2.label':
    'Describe el papel, si lo hay, que la espiritualidad / religión tiene en tu vida actualmente.',
  'step.2.question.q2.placeholder':
    'p. ej., Ahora mismo pienso en la espiritualidad como algo que estoy explorando. Estoy abierto a...',
  'step.2.question.q3.label':
    'Describe tu poder superior si tienes uno (p. ej., un juez perfeccionista, un abuelo bondadoso, una máquina expendedora, no está ahí)',
  'step.2.question.q3.placeholder':
    'p. ej., Mi poder superior es el grupo y la conexión que siento allí. No es religioso, pero...',
  'step.2.question.q4.label':
    'Describe cualquier sentimiento de enojo que hayas tenido o tengas hacia un poder superior.',
  'step.2.question.q4.placeholder':
    'p. ej., Me sentí enojado cuando mis oraciones no fueron respondidas. Pensé que un poder superior debería haber...',
  'step.2.question.q5.label':
    'Relata las ocasiones en que has rezado por algo o has hecho un trato con tu poder superior en momentos de angustia, y qué ocurrió después.',
  'step.2.question.q5.placeholder':
    'p. ej., Una vez recé cuando estaba desesperado por dejar de actuar compulsivamente. Le dije a Dios que yo...',
  'step.2.question.q6.label':
    'Si es apropiado, describe cómo alguien en tu vida abusó de su autoridad sobre ti y cómo eso afectó tu visión de un poder superior.',
  'step.2.question.q6.placeholder':
    'p. ej., Alguien en mi vida tenía control sobre mí cuando era joven. Me hizo difícil confiar...',

  'step.3.question.q1.label':
    '¿Quién o qué tomaba mis decisiones mientras actuaba sexualmente de forma compulsiva?',
  'step.3.question.q1.placeholder':
    'p. ej., Mis antojos e impulsos tomaban todas las decisiones. No sentía que tuviera opción...',
  'step.3.question.q2.label':
    '¿Qué temores tengo sobre tomar la decisión de poner mi voluntad y mi vida al cuidado de un poder superior como yo lo concibo?',
  'step.3.question.q2.placeholder':
    'p. ej., Temo que nada cambie y que me decepcione...',
  'step.3.question.q3.label': '¿Qué problemas he intentado resolver con fuerza de voluntad?',
  'step.3.question.q3.placeholder':
    'p. ej., Intenté dejar de actuar compulsivamente haciendo promesas y llevando un registro de mi conducta...',
  'step.3.question.q4.label':
    '¿Cómo han hecho sufrir mi propia voluntad y mis reacciones ante los hechos de la vida a mí y a otras personas? Sé específico.',
  'step.3.question.q4.placeholder':
    'p. ej., Estallé contra mi pareja cuando sentí vergüenza...',
  'step.3.question.q5.label': '¿Quién o qué toma mis decisiones en la recuperación?',
  'step.3.question.q5.placeholder':
    'p. ej., Hago una pausa y le pregunto a mi Poder Superior cuál es lo siguiente correcto...',
  'step.3.question.q6.label':
    '¿Sigue funcionando mi concepto actual de un poder superior, y cómo podría necesitar cambiar ese concepto?',
  'step.3.question.q6.placeholder':
    'p. ej., Mi concepto solía ser castigador. Ahora veo a mi Poder Superior como bondadoso y constante...',
  'step.3.question.q7.label':
    '¿Cuáles son ejemplos específicos de cómo puse mi vida y mi voluntad al cuidado de mi adicción?',
  'step.3.question.q7.placeholder':
    'p. ej., Falté al trabajo y le mentí a mi pareja solo para actuar compulsivamente...',
  'step.3.question.q8.label':
    '¿Cómo sería mi día si pusiera mi voluntad y mi vida al cuidado de un poder superior como yo lo concibo?',
  'step.3.question.q8.placeholder': 'p. ej., Me sentiría más tranquilo y más presente...',
  'step.3.question.q9.label':
    '¿Qué pensamientos y conductas estoy dispuesto a entregar ahora mismo, y cuáles aún no?',
  'step.3.question.q9.placeholder':
    'p. ej., Estoy dispuesto a soltar el intentar arreglar todo por mí mismo...',

  // Oración tradicional del Tercer Paso — texto publicado de Alcohólicos Anónimos (pág. 63),
  // usado también en SAA. No redactar una oración nueva.
  'step.3.prayer.traditional_heading':
    'Oración del Tercer Paso (de Alcohólicos Anónimos, página 63)',
  'step.3.prayer.traditional_line1':
    'Dios mío, me ofrezco a Ti para que hagas conmigo y edifiques en mí de acuerdo con tu voluntad.',
  'step.3.prayer.traditional_line2':
    'Líbrame de la esclavitud del ego, para que pueda cumplir mejor tu voluntad.',
  'step.3.prayer.traditional_line3':
    'Aparta de mí mis dificultades, para que la victoria sobre ellas sea testimonio, ante aquellos a quienes yo pueda ayudar, de tu Poder, tu Amor y tu manera de vivir.',
  'step.3.prayer.traditional_line4': '¡Que siempre haga yo tu voluntad!',
  'step.3.prayer.own_words_label': 'La Oración del Tercer Paso en mis propias palabras',
  'step.3.prayer.own_words_placeholder':
    'Escribe aquí tu propia versión de la Oración del Tercer Paso...',

  'workshop.2026.nav_label': 'Taller de Pasos 2026',
  'workshop.2026.default_name': 'Taller de Pasos SAA 2026',
  'workshop.2026.loading': 'Cargando el taller…',
  'workshop.2026.loading_schedule': 'Cargando horario…',
  'workshop.2026.loading_details': 'Cargando detalles del taller…',
  'workshop.2026.hero_subtitle':
    'Trabaja personalmente tus 12 pasos de SAA en comunidad con otros · En línea',
  'workshop.2026.starting': 'Comienza {date}',
  'workshop.2026.status_confirmed': 'Estás confirmado para el Taller SAA 2026.',
  'workshop.2026.status_first_session': 'Primera sesión: {date}.',
  'workshop.2026.tab_about': 'Acerca de',
  'workshop.2026.tab_workshop': 'Taller',

  'workshop.2026.about.interest_banner':
    'Estás en la lista de interés del taller 2026. Cuando estés listo para comprometerte, confirma que planeas asistir en la pestaña Taller — entonces aparecerá allí el enlace de Zoom.',
  'workshop.2026.about.see_workshop_tab': 'Ver pestaña Taller →',
  'workshop.2026.about.confirmed_banner':
    'Estás confirmado para el Taller SAA 2026',
  'workshop.2026.about.first_session_suffix': ' · Primera sesión: {date}',
  'workshop.2026.about.zoom_on_workshop_tab': 'El enlace de Zoom y el inicio del taller están en la',
  'workshop.2026.about.workshop_tab': 'pestaña Taller',

  'workshop.2026.about.what_heading': '¿Qué es un Taller de Pasos?',
  'workshop.2026.about.what_p1':
    'Un Taller de Pasos de SAA es un grupo de adictos en recuperación que se reúne regularmente para trabajar los 12 pasos de SAA y animarse mutuamente. Nos reunimos semanalmente a la misma hora en línea por Zoom. Los talleres suelen durar de 35 a 60 semanas, según el ritmo y el consenso del grupo.',
  'workshop.2026.about.what_p2':
    'La recuperación a menudo comienza en el aislamiento, pero la sanación ocurre en la conexión. Trabajar los pasos junto a otros nos da estructura, ánimo, impulso y la experiencia compartida de personas que realmente entienden lo que estamos viviendo. Escuchar a otros compartir con honestidad nos ayuda a vernos con más claridad y nos recuerda que no tenemos que recuperarnos solos. Lo que podría tomar años en solitario a menudo se logra en meses cuando caminamos el camino juntos.',

  'workshop.2026.about.for_me_heading': '¿Es este taller para mí?',
  'workshop.2026.about.for_me_li1': 'Disposición a trabajar los 12 pasos de SAA',
  'workshop.2026.about.for_me_li2': 'Puedo comprometerme a asistir semanalmente (la vida pasa; lo entendemos)',
  'workshop.2026.about.for_me_li3': 'Cómodo con reuniones en línea',
  'workshop.2026.about.for_me_li4': 'No se requiere trabajo previo en los pasos para comenzar',
  'workshop.2026.about.for_me_p1':
    'Este taller está abierto a cualquiera que busque recuperación de la conducta sexual compulsiva — sin importar género, orientación sexual, identidad de género, estado de relación o trasfondo. El único requisito es el deseo de dejar la conducta sexual adictiva.',
  'workshop.2026.about.for_me_p2':
    'También eres bienvenido y te animamos a unirte si ya has trabajado algunos o todos los pasos — para completarlos, trabajarlos de nuevo, ayudar a otros, profundizar tu recuperación o compartir tu sabiduría.',
  'workshop.2026.about.for_me_sponsor':
    'Necesitarás un padrino para completar el Paso Uno. Si aún no tienes uno, puedes unirte a las primeras reuniones mientras buscas uno — pero necesitarás un padrino antes de completar el Paso Uno.',

  'workshop.2026.about.week_heading': '¿Qué sucede cada semana?',
  'workshop.2026.about.week_li1': 'Lectura centrada en el paso juntos, compartir y ánimo',
  'workshop.2026.about.week_li2':
    'Trabajar juntos Primeros pasos, los 3 Círculos y los pasos 1 al 12',
  'workshop.2026.about.week_li3':
    'Entre reuniones del taller, los miembros registran el trabajo de los pasos en Recovery Commons — inventarios, progreso y compartir con un padrino',

  'workshop.2026.about.reg_heading': 'Cómo funciona el registro',
  'workshop.2026.about.reg_li1':
    'Crea una cuenta gratuita de Recovery Commons (o inicia sesión si ya tienes una)',
  'workshop.2026.about.reg_li2':
    'Únete a la lista de interés en la pestaña Taller arriba — te mantendremos informado por correo',
  'workshop.2026.about.reg_li3': 'Cuando estés listo, toca «Planeo asistir»',
  'workshop.2026.about.reg_li4':
    'Después de confirmar, el enlace de Zoom aparece en la pestaña Taller arriba',
  'workshop.2026.about.reg_signin_hint':
    'Cuando estés listo, ve a la pestaña Taller para crear una cuenta o iniciar sesión.',

  'workshop.2026.about.share_heading': 'Compartir e invitar',
  'workshop.2026.about.rc_heading': 'Trabajo de pasos en Recovery Commons',
  'workshop.2026.about.rc_body':
    'Los miembros registran inventarios, oraciones, listas de enmiendas y otro trabajo de pasos en privado en Recovery Commons. Desde la pestaña Taller, usa Trabajar mis pasos para abrir tu lista de pasos de SAA.',
  'workshop.2026.about.rc_help_link': 'Cómo funciona el trabajo de pasos en Recovery Commons',

  'workshop.2026.gate.lead':
    'Crea una cuenta gratuita de Recovery Commons para unirte a la lista de interés de este taller. ¿Ya tienes una cuenta? Inicia sesión.',
  'workshop.2026.gate.create_account': 'Crear cuenta',
  'workshop.2026.gate.sign_in': 'Iniciar sesión',
  'workshop.2026.gate.detail':
    'Después de unirte a la lista de interés y confirmar que planeas asistir, esta pestaña se convierte en tu inicio del taller: enlace de Zoom, calendario, lista telefónica y actualizaciones.',

  'workshop.2026.alert.interest_title': 'Estás en la lista de interés',
  'workshop.2026.alert.interest_body':
    'Tu interés en el Taller de Pasos SAA 2026 ha sido registrado.',
  'workshop.2026.alert.interest_email_sent':
    ' Enviamos un correo de confirmación a {email} con un enlace de regreso a esta página.',
  'workshop.2026.alert.interest_email_keep':
    ' Te mantendremos informado por correo en {email}.',
  'workshop.2026.alert.interest_email_generic':
    ' Te mantendremos informado por correo.',

  'workshop.2026.dialog.confirm_title': '¿Confirmas que planeas asistir?',
  'workshop.2026.dialog.confirm_message':
    'Esto les indica a los facilitadores que pretendes unirte al Taller SAA 2026. El enlace de Zoom aparecerá en esta pestaña cuando se publique.',
  'workshop.2026.dialog.confirm_ok': 'Planeo asistir',
  'workshop.2026.dialog.confirm_cancel': 'Todavía no',
  'workshop.2026.alert.confirmed_title': 'Estás confirmado',
  'workshop.2026.alert.confirmed_body':
    'Estás confirmado para el Taller de Pasos SAA 2026. Primera sesión: {date}.{emailNote} El enlace de Zoom aparecerá en la pestaña Taller cuando esté listo.',
  'workshop.2026.alert.confirm_error': 'No se pudo confirmar la asistencia.',

  'workshop.2026.dialog.leave_title_confirmed': '¿Salir del Taller SAA 2026?',
  'workshop.2026.dialog.leave_title_interest': '¿Salir de la lista de interés?',
  'workshop.2026.dialog.leave_message_confirmed':
    'Serás eliminado de la lista de participantes y de las listas de contacto del Taller SAA 2026. Salir solo afecta tu membresía del taller — tu trabajo de pasos en Recovery Commons permanece contigo. Puedes unirte de nuevo en cualquier momento.',
  'workshop.2026.dialog.leave_message_interest':
    'Serás eliminado de la lista de interés y dejarás de recibir actualizaciones sobre el Taller SAA 2026. Puedes unirte de nuevo en cualquier momento.',
  'workshop.2026.dialog.leave_ok_confirmed': 'Salir del taller',
  'workshop.2026.dialog.leave_ok_interest': 'Eliminarme',
  'workshop.2026.dialog.leave_cancel_confirmed': 'Seguir registrado',
  'workshop.2026.dialog.leave_cancel_interest': 'Mantenerme en la lista',
  'workshop.2026.alert.leave_error': 'No se pudo eliminarte del taller.',

  'workshop.2026.tab.config_missing':
    'El registro del taller aún no está disponible — un administrador debe vincular esta página a un registro de taller.',
  'workshop.2026.tab.join_heading': 'Únete al taller 2026',
  'workshop.2026.tab.join_body':
    'Únete a la lista de interés para recibir actualizaciones sobre la fecha de inicio por correo. Cuando estés listo para comprometerte, confirmarás que planeas asistir — entonces aparecerá aquí el enlace de Zoom.',
  'workshop.2026.tab.join_cta': 'Unirme a la lista de interés',
  'workshop.2026.tab.next_step_title': 'Tu siguiente paso',
  'workshop.2026.tab.on_interest_list': 'En la lista de interés',
  'workshop.2026.tab.on_interest_list_since': 'En la lista de interés desde {date}',
  'workshop.2026.tab.confirm_checklist':
    'Confirma que planeas asistir — antes de la primera sesión',
  'workshop.2026.tab.zoom_checklist': 'Enlace de Zoom — disponible después de confirmar',
  'workshop.2026.tab.confirming': 'Confirmando…',
  'workshop.2026.tab.confirm_cta': 'Planeo asistir',

  'workshop.2026.card.participants': 'Participantes del taller',
  'workshop.2026.card.community': 'Comunidad del taller',
  'workshop.2026.card.phone_list': 'Lista telefónica',
  'workshop.2026.card.resources': 'Recursos del taller',
  'workshop.2026.card.share': 'Compartir e invitar',
  'workshop.2026.card.calendar': 'Calendario del taller',

  'workshop.2026.zoom.heading': 'Unirse en vivo · Zoom',
  'workshop.2026.zoom.locked_helper':
    'Disponible después de confirmar que planeas asistir.',
  'workshop.2026.zoom.open': 'Abrir reunión de Zoom',
  'workshop.2026.zoom.copy': 'Copiar enlace',
  'workshop.2026.zoom.copied': '¡Copiado!',
  'workshop.2026.zoom.passphrase_hint': 'El enlace incluye la frase de acceso.',
  'workshop.2026.zoom.placeholder':
    'El enlace de Zoom aparecerá aquí antes de la primera sesión.',

  'workshop.2026.leave.title': 'Salir del taller',
  'workshop.2026.leave.body_confirmed':
    'Puedes salir en cualquier momento. Tu nombre se eliminará de la lista de participantes y de las listas de contacto. Salir solo afecta tu membresía del taller — tu trabajo de pasos en Recovery Commons permanece contigo. Puedes volver a unirte más adelante si cambian tus planes.',
  'workshop.2026.leave.body_interest':
    'Puedes salir de la lista de interés en cualquier momento y dejar de recibir correos del taller. Puedes volver a unirte más adelante si cambian tus planes.',
  'workshop.2026.leave.btn_confirmed': 'Salir del Taller SAA 2026',
  'workshop.2026.leave.btn_interest': 'Salir de la lista de interés',
  'workshop.2026.leave.removing': 'Eliminando…',

  'workshop.2026.interest_modal.title': 'Unirse a la lista de interés',
  'workshop.2026.interest_modal.subtitle':
    'Algunas preguntas para prepararnos para el Taller SAA 2026. Por favor responde todas las preguntas mostradas.',
  'workshop.2026.interest_modal.close': 'Cerrar',
  'workshop.2026.interest_modal.select': 'Seleccionar…',
  'workshop.2026.interest_modal.cancel': 'Cancelar',
  'workshop.2026.interest_modal.submit': 'Unirme a la lista de interés',
  'workshop.2026.interest_modal.submitting': 'Enviando…',
  'workshop.2026.interest_modal.error': 'No se pudo registrar el interés',

  'workshop.2026.interest_survey.saa_tenure.label':
    '¿Cuánto tiempo llevas asistiendo a reuniones de SAA?',
  'workshop.2026.interest_survey.saa_tenure.new': 'Soy nuevo',
  'workshop.2026.interest_survey.saa_tenure.lt_1_year': '< 1 año',
  'workshop.2026.interest_survey.saa_tenure.1_3_years': '1-3 años',
  'workshop.2026.interest_survey.saa_tenure.3_10_years': '3-10 años',
  'workshop.2026.interest_survey.saa_tenure.10_plus_years': '10+ años',
  'workshop.2026.interest_survey.steps_worked.label':
    '¿Has trabajado los 12 pasos de SAA antes?',
  'workshop.2026.interest_survey.steps_worked.none': 'No',
  'workshop.2026.interest_survey.steps_worked.some': 'Algunos pasos',
  'workshop.2026.interest_survey.steps_worked.all': 'Los 12 pasos',
  'workshop.2026.interest_survey.workshop_experience.label':
    '¿Has trabajado los pasos en un taller o grupo de estudio de pasos antes?',
  'workshop.2026.interest_survey.workshop_experience.no': 'No',
  'workshop.2026.interest_survey.workshop_experience.yes': 'Sí',
  'workshop.2026.interest_survey.last_step_completed.label':
    '¿Cuál es el último paso que completaste?',
  'workshop.2026.interest_survey.last_step_completed.option': 'Paso {n}',
  'workshop.2026.interest_survey.has_sponsor.label':
    '¿Tienes actualmente un padrino?',
  'workshop.2026.interest_survey.has_sponsor.yes': 'Sí',
  'workshop.2026.interest_survey.has_sponsor.no': 'No',
  'workshop.2026.interest_survey.has_sponsor.looking': 'Estoy buscando uno',
  'workshop.2026.interest_survey.has_sponsor.helper':
    'Se requiere un padrino para completar el Paso Uno.',
  'workshop.2026.interest_survey.help_facilitate.label':
    '¿Te interesa ayudar a facilitar o apoyar el taller?',
  'workshop.2026.interest_survey.help_facilitate.yes': 'Sí',
  'workshop.2026.interest_survey.help_facilitate.maybe': 'Tal vez más adelante',
  'workshop.2026.interest_survey.help_facilitate.no': 'No',
  'workshop.2026.interest_survey.validation_required': 'Por favor responde: {question}.',

  'workshop.2026.share.lead':
    'Comparte esta página, o imprime un folleto de una página del taller para compartir en las reuniones.',
  'workshop.2026.share.copy': 'Copiar enlace a esta página',
  'workshop.2026.share.copied': '¡Copiado!',
  'workshop.2026.share.flyer': 'Ver / Imprimir folleto',

  'workshop.2026.step_work.cta': 'Trabajar mis pasos',
  'workshop.2026.resources.empty': 'Aún no se han agregado recursos del taller.',
  'workshop.2026.calendar.empty_underway':
    'El calendario de pasos aparecerá aquí cuando el taller esté en marcha.',
  'workshop.2026.calendar.empty_progress':
    'Los detalles del calendario se publicarán aquí a medida que el grupo avance.',
  'workshop.2026.calendar.current_step': 'Paso actual',
  'workshop.2026.calendar.started_step': 'Comenzamos este paso',
  'workshop.2026.calendar.where_we_are': 'Dónde estamos',
  'workshop.2026.calendar.likely_complete': 'Probablemente completo',

  'workshop.2026.preferences.card_title': 'Mis preferencias para este taller',
  'workshop.2026.preferences.card_hint':
    'Lista telefónica, lista de correo y disponibilidad para apadrinar — solo visible para miembros del taller.',
  'workshop.2026.preferences.standalone_hint':
    'Puedes actualizar esto en cualquier momento. Solo los miembros del taller ven esta información.',
  'workshop.2026.preferences.give_to_get_title': 'Compartir es mutuo — «dar para recibir»',
  'workshop.2026.preferences.give_to_get_lead': 'Solo verás lo que estás dispuesto a compartir:',
  'workshop.2026.preferences.give_names': 'Ver los nombres de los miembros solo si muestras el tuyo',
  'workshop.2026.preferences.give_phones': 'Ver los teléfonos de los miembros solo si listas el tuyo',
  'workshop.2026.preferences.give_emails': 'Ver los correos de los miembros solo si listas el tuyo',
  'workshop.2026.preferences.email_login_note':
    'Tu correo es el de inicio de sesión de tu cuenta — no se puede cambiar en Recovery Commons.',
  'workshop.2026.preferences.name_heading': 'Mi nombre en la lista de miembros',
  'workshop.2026.preferences.name_help': 'Verás los nombres de otros miembros solo si muestras el tuyo.',
  'workshop.2026.preferences.name_never': 'No mostrar nunca mi nombre',
  'workshop.2026.preferences.name_at_start': 'Mostrar mi nombre cuando comience el taller ({startSchedule})',
  'workshop.2026.preferences.name_now': 'Mostrar mi nombre ahora (visible para otros miembros confirmados)',
  'workshop.2026.preferences.phone_heading': 'Lista telefónica del taller',
  'workshop.2026.preferences.phone_help':
    'Agrega tu número para ver los de otros miembros. La lista compartida se activa en la primera sesión ({startSchedule}) y permanece durante el resto del taller.',
  'workshop.2026.preferences.phone_yes': 'Sí, listar mi número (y ver los de otros)',
  'workshop.2026.preferences.phone_no': 'No — no veré los teléfonos de otros miembros',
  'workshop.2026.preferences.saved_number': 'Número guardado: {phone}',
  'workshop.2026.preferences.update_number': 'Actualizar mi número',
  'workshop.2026.preferences.view_profile': 'Ver mi perfil',
  'workshop.2026.preferences.phone_label': 'Número de teléfono',
  'workshop.2026.preferences.phone_updates_profile':
    'Actualiza tu perfil de Recovery Commons para todas las reuniones.',
  'workshop.2026.preferences.phone_saved_note':
    'Se guarda en tu perfil de Recovery Commons y se usa cuando la lista se active.',
  'workshop.2026.preferences.phone_placeholder': 'p. ej. (555) 123-4567',
  'workshop.2026.preferences.saving': 'Guardando…',
  'workshop.2026.preferences.save_number': 'Guardar número',
  'workshop.2026.preferences.cancel': 'Cancelar',
  'workshop.2026.preferences.phone_saved': 'Número de teléfono guardado.',
  'workshop.2026.preferences.email_heading': 'Lista de correo del taller',
  'workshop.2026.preferences.email_help_with':
    'Esto comparte el correo de tu cuenta ({email}) con miembros confirmados. Misma sincronización que la lista telefónica.',
  'workshop.2026.preferences.email_help':
    'Esto comparte el correo de tu cuenta con miembros confirmados. Misma sincronización que la lista telefónica.',
  'workshop.2026.preferences.email_yes': 'Sí, compartir el correo de mi cuenta (y ver los de otros)',
  'workshop.2026.preferences.email_no': 'No — no veré los correos de otros miembros',
  'workshop.2026.preferences.shared_from_account': 'Compartido desde tu cuenta: {email}',
  'workshop.2026.preferences.email_login_used':
    'Este es tu correo de inicio de sesión, usado cuando optas por la lista de correo del taller.',
  'workshop.2026.preferences.sponsor_heading': 'Disponible para apadrinar',
  'workshop.2026.preferences.sponsor_help':
    '¿Dispuesto a aparecer como padrino disponible en la lista telefónica del taller?',
  'workshop.2026.preferences.yes': 'Sí',
  'workshop.2026.preferences.yes_temporary': 'Sí, temporal',
  'workshop.2026.preferences.no': 'No',
  'workshop.2026.preferences.saved': 'Preferencias guardadas.',

  'workshop.2026.preferences.summary.name_label': 'Nombre en la lista',
  'workshop.2026.preferences.summary.name_now': 'Mostrando ahora',
  'workshop.2026.preferences.summary.name_at_start': 'Cuando comience el taller',
  'workshop.2026.preferences.summary.name_never': 'No mostrar nunca',
  'workshop.2026.preferences.summary.phone_label': 'Teléfono en la lista',
  'workshop.2026.preferences.summary.email_label': 'Correo en la lista',
  'workshop.2026.preferences.summary.sponsor_label': 'Disponible para apadrinar',
  'workshop.2026.preferences.summary.temporary': 'Temporal',
  'workshop.2026.preferences.summary.add_number': 'Sí — agrega tu número',
  'workshop.2026.preferences.summary.no_contact': 'Sin información de contacto compartida',
  'workshop.2026.preferences.summary.sharing_email': 'Compartiendo correo',
  'workshop.2026.preferences.summary.sharing_phone': 'Compartiendo teléfono',
  'workshop.2026.preferences.summary.sharing_phone_add': 'Compartiendo teléfono (agregar número)',
  'workshop.2026.preferences.summary.sharing_both': 'Compartiendo teléfono y correo',
  'workshop.2026.preferences.summary.name_now_frag': 'nombre en la lista ahora',
  'workshop.2026.preferences.summary.name_start_frag': 'nombre al inicio',
  'workshop.2026.preferences.summary.name_not_listed': 'nombre no listado',
  'workshop.2026.preferences.summary.open_sponsor': 'disponible para apadrinar',
  'workshop.2026.preferences.summary.temp_sponsor': 'padrino temporal',

  'workshop.2026.phone_list.give_to_get':
    'Compartir es mutuo: ves los teléfonos de los miembros solo si listas el tuyo, y sus correos solo si listas el tuyo.',
  'workshop.2026.phone_list.not_available':
    'La lista telefónica aún no está disponible. El facilitador puede habilitarla en la configuración del taller.',
  'workshop.2026.phone_list.need_verified':
    'Debes ser un miembro confirmado y verificado para ver la lista telefónica.',
  'workshop.2026.phone_list.locked_title': 'Agrega tu número de teléfono para ver la lista',
  'workshop.2026.phone_list.locked_body':
    'Compartir es mutuo — lista tu número y verás a todos los que hayan optado por participar.',
  'workshop.2026.phone_list.update_prefs': 'Actualizar mis preferencias',
  'workshop.2026.phone_list.loading': 'Cargando lista telefónica…',
  'workshop.2026.phone_list.load_error': 'No se pudo cargar la lista telefónica',
  'workshop.2026.phone_list.empty': 'Ningún otro miembro ha agregado su número todavía.',
  'workshop.2026.phone_list.share_email_hint':
    'Comparte tu correo en preferencias para ver las direcciones de correo de los miembros.',
  'workshop.2026.phone_list.col_name': 'Nombre',
  'workshop.2026.phone_list.col_phone': 'Teléfono',
  'workshop.2026.phone_list.col_email': 'Correo',
  'workshop.2026.phone_list.col_sponsor': '¿Padrino?',
  'workshop.2026.phone_list.col_sponsor_print': 'Padrino',
  'workshop.2026.phone_list.sponsor_yes': 'Sí',
  'workshop.2026.phone_list.sponsor_temp': 'Temp',
  'workshop.2026.phone_list.dash': '—',
  'workshop.2026.phone_list.share_email_to_see': 'Comparte tu correo para ver',
  'workshop.2026.phone_list.print': 'Imprimir lista telefónica',
  'workshop.2026.phone_list.print_title': '{workshopName} — Lista telefónica',
  'workshop.2026.phone_list.print_meta': 'Lista telefónica · {date}',
  'workshop.2026.phone_list.print_privacy':
    'Privado — solo para miembros del taller. Mantén esta información confidencial y no la compartas fuera del taller.',
  'workshop.2026.phone_list.print_email_hidden':
    'Los correos están ocultos porque no estás compartiendo el tuyo. Agrega tu correo en las preferencias del taller para verlos.',
  'workshop.2026.phone_list.member_fallback': 'Miembro',

  'workshop.2026.community.loading': 'Cargando…',
  'workshop.2026.community.load_error': 'No se pudo cargar la información de participantes',
  'workshop.2026.community.still_deciding': 'Quiénes aún deciden ({count})',
  'workshop.2026.community.lists_at_start':
    'Las listas de teléfono y correo estarán disponibles para miembros confirmados cuando comience el taller ({firstSession}). Puedes optar en preferencias.',
  'workshop.2026.community.lists_at_start_tbd':
    'Las listas de teléfono y correo estarán disponibles para miembros confirmados cuando comience el taller. Puedes optar en preferencias.',

  'workshop.2026.roster.confirmed_1': '(1 confirmado)',
  'workshop.2026.roster.confirmed_n': '({count} confirmados)',
  'workshop.2026.roster.deciding_1': '({total} con 1 aún decidiendo)',
  'workshop.2026.roster.deciding_n': '({total} con {count} aún decidiendo)',
  'workshop.2026.roster.community_title': 'Comunidad del taller',
  'workshop.2026.roster.participants_title': 'Participantes del taller {headerCount}',
  'workshop.2026.roster.confirmed_short_1': '1 confirmado',
  'workshop.2026.roster.confirmed_short_n': '{count} confirmados',
  'workshop.2026.roster.interest_short_1': '1 en la lista de interés',
  'workshop.2026.roster.interest_short_n': '{count} en la lista de interés',
  'workshop.2026.roster.subtitle_combo': '{confirmed} · {interest}',
  'workshop.2026.roster.no_confirmed': 'Aún no hay participantes confirmados.',
  'workshop.2026.roster.joining_1': '1 persona ha confirmado y se unirá.',
  'workshop.2026.roster.joining_n': '{count} personas han confirmado y se unirán.',
  'workshop.2026.roster.plus_1_other': '{names} + 1 más',
  'workshop.2026.roster.plus_n_others': '{names} + {count} más',
  'workshop.2026.roster.names_period': '{names}.',
  'workshop.2026.roster.interest_empty': 'Nadie está en la lista de interés en este momento.',
  'workshop.2026.roster.interest_1': 'Una persona está en la lista de interés y aún no ha confirmado.',
  'workshop.2026.roster.interest_n': '{count} personas están en la lista de interés y aún no han confirmado.',
  'workshop.2026.roster.viewer_confirmed_1': '1 persona ha confirmado.',
  'workshop.2026.roster.viewer_confirmed_n': '{count} personas han confirmado.',
  'workshop.2026.roster.viewer_planning_1': '1 persona ha confirmado que planea asistir.',
  'workshop.2026.roster.viewer_planning_n': '{count} personas han confirmado que planean asistir.',
  'workshop.2026.roster.viewer_interest_1': '1 persona está en la lista de interés y aún no ha confirmado{suffix}.',
  'workshop.2026.roster.viewer_interest_n': '{count} personas están en la lista de interés y aún no han confirmado{suffix}.',
  'workshop.2026.roster.including_you': ' (incluyéndote a ti)',

  'workshop.2026.first_step.title': 'Inscripción para presentar el Primer Paso',
  'workshop.2026.first_step.loading': 'Cargando inscripción de presentación…',
  'workshop.2026.first_step.not_open':
    'La inscripción para presentar el Primer Paso aún no está abierta. Tu facilitador la habilitará cuando el taller comience el Paso Uno.',
  'workshop.2026.first_step.load_error': 'No se pudo cargar la hoja de inscripción',
  'workshop.2026.first_step.week_locked': 'Esa semana está bloqueada.',
  'workshop.2026.first_step.removed': 'Eliminaste tu inscripción.',
  'workshop.2026.first_step.remove_error': 'No se pudo eliminar la inscripción',
  'workshop.2026.first_step.updated': 'Inscripción actualizada.',
  'workshop.2026.first_step.update_error': 'No se pudo actualizar la inscripción',
  'workshop.2026.first_step.archived':
    'Este horario está archivado de cuando la inscripción del Paso Uno estaba abierta.',
  'workshop.2026.first_step.instructions':
    'Inscríbete en un espacio: presentar en este taller, ser suplente, o marcar que presentaste fuera (otra reunión). Toca una celda abierta para inscribirte o moverte. Toca tu nombre para quitar tu inscripción.',
  'workshop.2026.first_step.week': 'Semana {n}',
  'workshop.2026.first_step.add_present': '+ Presentar',
  'workshop.2026.first_step.add_alt': '+ Supl.',
  'workshop.2026.first_step.add_outside': '+ Fuera',
  'workshop.2026.first_step.you_suffix': '{name} (tú)',
  'workshop.2026.first_step.member': 'Miembro',
  'workshop.2026.first_step.summary_loading': 'Cargando…',
  'workshop.2026.first_step.summary_not_open': 'Aún no abierto',
  'workshop.2026.first_step.summary_not_signed': 'Aún no inscrito',
  'workshop.2026.first_step.summary_signed_dated':
    'Inscrito como {role} para la semana {week} — {date}',
  'workshop.2026.first_step.summary_signed': 'Inscrito como {role} para la semana {week}',
  'workshop.2026.first_step.role_presenter': 'presentador',
  'workshop.2026.first_step.role_alternate': 'suplente',
  'workshop.2026.first_step.role_outside': 'presentado fuera',
  'workshop.2026.first_step.status_alternate':
    'Estás inscrito como suplente para la semana {week}.',
  'workshop.2026.first_step.status_outside':
    'Estás inscrito como presentado fuera del taller para la semana {week}.',
  'workshop.2026.first_step.status_presenter':
    'Estás inscrito como presentador para la semana {week}.',
  'workshop.2026.first_step.band_in': 'En el taller',
  'workshop.2026.first_step.band_alts': 'Suplentes',
  'workshop.2026.first_step.band_outside': 'Fuera del taller',
  'workshop.2026.first_step.col_presenter': 'Presentador',
  'workshop.2026.first_step.col_presenter_n': 'Presentador {n}',
  'workshop.2026.first_step.col_alternate': 'Suplente',
  'workshop.2026.first_step.col_alternate_n': 'Suplente {n}',
  'workshop.2026.first_step.col_outside': 'Fuera',
  'workshop.2026.first_step.col_outside_full': 'Fuera del taller',
  'workshop.2026.first_step.col_outside_n': 'Fuera {n}',
  'workshop.2026.first_step.short_present': 'Presentar',
  'workshop.2026.first_step.short_alt': 'Supl.',
  'workshop.2026.first_step.short_outside': 'Fuera',

  'workshop.2026.discovery.title': '¿Trabajando los pasos de nuevo?',
  'workshop.2026.discovery.body':
    '— Tienes trabajo de pasos de antes de unirte a este taller. Usa Guardar y empezar de nuevo en el menú para archivarlo y comenzar fresco para el taller. Guardamos una copia para ti.',
  'workshop.2026.discovery.cta': 'Guardar y empezar de nuevo',
  'workshop.2026.discovery.dismiss': 'Descartar',

  'workshop.2026.schedule.sunday': 'Domingo',
  'workshop.2026.schedule.sundays': 'Domingos',
  'workshop.2026.schedule.monday': 'Lunes',
  'workshop.2026.schedule.mondays': 'Lunes',
  'workshop.2026.schedule.tuesday': 'Martes',
  'workshop.2026.schedule.tuesdays': 'Martes',
  'workshop.2026.schedule.wednesday': 'Miércoles',
  'workshop.2026.schedule.wednesdays': 'Miércoles',
  'workshop.2026.schedule.thursday': 'Jueves',
  'workshop.2026.schedule.thursdays': 'Jueves',
  'workshop.2026.schedule.friday': 'Viernes',
  'workshop.2026.schedule.fridays': 'Viernes',
  'workshop.2026.schedule.saturday': 'Sábado',
  'workshop.2026.schedule.saturdays': 'Sábados',
  'workshop.2026.schedule.start_date_tbd': '{day}, {time} (fecha de inicio por definir)',
  'workshop.2026.schedule.first_meeting_tbd': 'Primera reunión: {day}, {time} (fecha por definir)',
  'workshop.2026.schedule.first_meeting': 'Primera reunión: {date} · {time}',
  'workshop.2026.schedule.next_meeting': 'Próxima reunión: {date} · {time}',
  'workshop.2026.schedule.date_tbd': 'fecha por definir',
  'workshop.2026.schedule.day_time': '{day}, {time}',

  'workshop.2026.faq.heading': 'Preguntas frecuentes',
  'workshop.2026.faq.ask_signin': 'Inicia sesión para enviar una pregunta a los facilitadores del taller.',
  'workshop.2026.faq.ask_signin_cta': 'Inicia sesión para preguntar',
  'workshop.2026.faq.ask_thanks': 'Gracias — tu pregunta ha sido enviada.',
  'workshop.2026.faq.ask_another': 'Hacer otra pregunta',
  'workshop.2026.faq.ask_label': 'Tu pregunta',
  'workshop.2026.faq.ask_placeholder': '¿Qué te gustaría saber?',
  'workshop.2026.faq.ask_error': 'No se pudo enviar tu pregunta',
  'workshop.2026.faq.ask_sending': 'Enviando…',
  'workshop.2026.faq.ask_send': 'Enviar pregunta',
  'workshop.2026.faq.time_commitment_answer':
    'El taller se reúne {schedule}, en línea. Más allá de la reunión, dedicarás tiempo al trabajo de pasos entre sesiones — inventarios, escritura y reuniones con tu padrino. Eso varía según el paso y la persona.',
  'workshop.2026.faq.past_workshops_answer':
    'Sí. Este es nuestro 12.º taller anual de pasos. En los 11 talleres que hemos celebrado desde 2009, más de 200 personas han trabajado los 12 Pasos de principio a fin.',

  'workshop.2026.faq.what-is-workshop.question': '¿Qué es un taller de pasos de SAA?',
  'workshop.2026.faq.what-is-workshop.answer':
    'Un taller de pasos es un grupo facilitado que trabaja los 12 pasos de SAA juntos a lo largo de muchos meses. Nos reunimos a la misma hora cada semana en línea por Zoom. El grupo se mantiene en gran medida estable para construir confianza, honestidad e impulso — trabajando los pasos en comunidad en lugar de solos.',
  'workshop.2026.faq.who-is-it-for.question': '¿Para quién es este taller?',
  'workshop.2026.faq.who-is-it-for.answer':
    'Cualquier persona con el deseo de dejar la conducta sexual adictiva que esté dispuesta a trabajar los 12 pasos de SAA, pueda comprometerse a asistir semanalmente (la vida pasa; lo entendemos) y se sienta cómoda con las reuniones en línea — la misma base que las reuniones de SAA. No se requiere trabajo de pasos previo. Quienes ya hayan trabajado algunos o todos los pasos también son bienvenidos — para completarlos, volver a trabajarlos y profundizar en la recuperación, o compartir sabiduría.',
  'workshop.2026.faq.open-to-everyone.question': '¿Este taller está abierto a todos?',
  'workshop.2026.faq.open-to-everyone.answer':
    'Sí. Este taller da la bienvenida a cualquiera que busque recuperación de la conducta sexual compulsiva — sin importar género, orientación sexual, identidad de género, estado de relación, fe o trasfondo. El único requisito de membresía de SAA es el deseo de dejar la conducta sexual adictiva. Aquí perteneces.',
  'workshop.2026.faq.sponsor.question': '¿Necesito un padrino?',
  'workshop.2026.faq.sponsor.answer':
    'Necesitarás un padrino para completar el Paso Uno. Si aún no tienes uno, está bien — parte de prepararse para el taller es pensar en el apadrinamiento, y el grupo puede ayudarte a considerar cómo encontrar uno.',
  'workshop.2026.faq.how-long.question': '¿Cuánto dura el taller?',
  'workshop.2026.faq.how-long.answer':
    'No hay un número fijo de semanas. Los talleres suelen durar de 35 a 60 semanas, según el ritmo y el consenso del grupo. Trabajamos un paso a la vez y avanzamos cuando el grupo está listo.',
  'workshop.2026.faq.cost.question': '¿Hay algún costo por el taller?',
  'workshop.2026.faq.cost.answer':
    'No. No hay costo para unirse — el taller y Recovery Commons son un trabajo de amor, ofrecidos libremente en el espíritu de un adicto ayudando a otro. No hay tarifas, cuotas ni cargos para participar.',
  'workshop.2026.faq.weekly-session.question': '¿Qué ocurre en cada sesión semanal?',
  'workshop.2026.faq.weekly-session.answer':
    'Las sesiones se centran en el paso actual con lectura enfocada en el paso juntos, compartir y ánimo. Entre sesiones, los miembros aprenden y registran su trabajo de pasos en Recovery Commons mientras trabajan con sus padrinos y otras personas del programa.',
  'workshop.2026.faq.registration.question': '¿Cómo me registro?',
  'workshop.2026.faq.registration.answer':
    'Ve a la pestaña Taller arriba, crea una cuenta gratuita de Recovery Commons e indica tu interés. Cuando estés listo para comprometerte, confirma que planeas asistir — entonces el enlace de Zoom aparece en la pestaña Taller arriba antes de la primera sesión. ¿Te perdiste la primera reunión? Aún puedes registrarte y unirte cuando estés listo.',
  'workshop.2026.faq.time-commitment.question': '¿Cuál es el compromiso de tiempo semanal?',
  'workshop.2026.faq.past-workshops.question': '¿Han dirigido talleres como este antes?',
  'workshop.2026.faq.recovery-commons.question': '¿Qué es Recovery Commons y cómo encaja?',
  'workshop.2026.faq.recovery-commons.answer':
    'Como facilitador de estos talleres, he visto cuánto más fácil se recuperan las personas cuando tienen un camino claro a través de los pasos, un lugar para registrar su trabajo y una forma sencilla de compartir con su padrino entre las reuniones semanales. Construí Recovery Commons para capturar lo que hemos aprendido a lo largo de muchos años de experiencia en talleres y para dar a los miembros un hogar estructurado y privado para su trabajo de pasos.\n\nRecovery Commons es una herramienta en línea gratuita para tu trabajo de 12 pasos — acciones guiadas, inventarios y progreso que te pertenecen. Los miembros del taller la usan entre sesiones para mantenerse al día y, opcionalmente, compartir con un padrino. El taller en sí (Zoom, calendario, lista telefónica) vive en esta página bajo la pestaña Taller.',
  'workshop.2026.faq.privacy.question': '¿Mi trabajo de pasos es privado?',
  'workshop.2026.faq.privacy.answer':
    'Sí. Tu trabajo sensible de pasos en Recovery Commons está cifrado; solo tú puedes leerlo. Los facilitadores del taller no leen ni pueden leer tus inventarios privados ni tu escritura de pasos. Compartir con un padrino u otras personas está enteramente bajo tu control.',
  'workshop.2026.faq.ask.question': '¿Tienes una pregunta que no se responde aquí?',

  'workshop.2026.faq.past.2025_2026': 'Sábados, abr 2025 – may 2026 · 20 personas · En línea',
  'workshop.2026.faq.past.2024_2025': 'Sábados, mar 2024 – mar 2025 · 20 · En línea',
  'workshop.2026.faq.past.2023': 'Miércoles, ene 2023 – oct 2023 · 15 · En línea',
  'workshop.2026.faq.past.2022': 'Sábados, ene 2022 – oct 2022 · 20 · En línea',
  'workshop.2026.faq.past.2021': 'Sábados, feb 2021 – oct 2021 · 20 · En línea',
  'workshop.2026.faq.past.2019_2021': 'Sábados, sep 2019 – mar 2021 · 20 · San José, CA + En línea',
  'workshop.2026.faq.past.2018_2019': 'Jueves, ene 2018 – may 2019 · 20 · Indianápolis, IN',
  'workshop.2026.faq.past.2016_2017': 'Martes, ene 2016 – mar 2017 · 15 · Fishers, IN',
  'workshop.2026.faq.past.2013_2015': 'Jueves, nov 2013 – feb 2015 · 25 · Indianápolis, IN',
  'workshop.2026.faq.past.2011_2012': 'Lunes, ene 2011 – jun 2012 · 20 · Brownsburg, IN',
  'workshop.2026.faq.past.2009_2010': 'Jueves, jun 2009 – ago 2010 · 30 · Indianápolis, IN',

  'step.page.error.load': 'No se pudo cargar tu progreso. Intenta actualizar la página.',
  'step.page.error.save_progress': 'No se pudo guardar el progreso. Inténtalo de nuevo.',
  'step.page.error.sign_in': 'Inicia sesión para guardar tu progreso.',
  'step.page.error.save_sponsor': 'No se pudo guardar el estado de padrino.',

  'auth.error.title': 'Sesión expirada',
  'auth.error.session_expired':
    'Tu sesión expiró. Vuelve a iniciar sesión para continuar.',
  'auth.error.session_expired_save':
    'Tu sesión expiró. Vuelve a iniciar sesión para guardar tu progreso.',
  'auth.error.session_invalid': 'Tu sesión ya no es válida. Vuelve a iniciar sesión.',
  'auth.error.please_log_in': 'Inicia sesión para continuar.',
  'auth.error.no_token': 'No se encontró un token de autenticación. Inicia sesión.',
  'auth.error.not_logged_in': 'No has iniciado sesión. Inicia sesión.',
  'auth.error.generic': 'Ocurrió un error. Inténtalo de nuevo.',
  'auth.error.log_in_again': 'Volver a iniciar sesión',
  'auth.error.help_after_login': 'Después de iniciar sesión, tu trabajo se guardará automáticamente.',

  'step.help.close_aria': 'Cerrar ayuda',
  'step.help.button_title': 'Ayuda',
  'step.help.link_default': 'Cómo funciona el trabajo de pasos en Recovery Commons',
  'step.help.panel_title_app': 'Ayuda: Recovery Commons',
  'step.help.panel_title_workshop': 'Ayuda: Taller',

  'working_steps.page.title': 'Trabajando los 12 Pasos de SAA',
  'working_steps.page.description':
    'Los 12 Pasos de Sex Addicts Anonymous ofrecen un camino probado hacia la recuperación de la adicción sexual. Cada paso se construye sobre los anteriores, creando un programa integral de sanación espiritual y emocional.',
  'working_steps.loading': 'Cargando tu progreso…',
  'working_steps.loading_sub': 'Espera mientras recuperamos los datos de tus pasos',
  'working_steps.login.title': 'Sigue tu progreso',
  'working_steps.login.body':
    'Inicia sesión o crea una cuenta para seguir tu progreso en los 12 pasos y recibir orientación y apoyo en tu camino de recuperación.',
  'working_steps.login.login': 'Iniciar sesión',
  'working_steps.login.create': 'Crear cuenta',
  'working_steps.desc.1':
    'El primer paso implica una autoevaluación honesta y admitir la impotencia ante la adicción sexual.',
  'working_steps.desc.2':
    'Desarrollar la fe en un poder superior que puede ayudar a restaurar la salud mental y emocional.',
  'working_steps.desc.3':
    'Entregar el control y confiar en un poder superior para guía y fuerza.',
  'working_steps.desc.4':
    'Un autoexamen profundo de resentimientos, temores y daños causados a otros.',
  'working_steps.desc.5':
    'Compartir el inventario con una persona de confianza y experimentar el alivio de la honestidad.',
  'working_steps.desc.6':
    'Disponerse a dejar ir los defectos de carácter y los patrones negativos.',
  'working_steps.desc.7':
    'Pedir ayuda para quitar los defectos de carácter y cultivar la humildad.',
  'working_steps.desc.8':
    'Identificar a quienes fueron dañados por nuestras acciones y prepararse para enmendar.',
  'working_steps.desc.9':
    'Actuar para reparar relaciones y enmendar donde sea apropiado.',
  'working_steps.desc.10':
    'Autoexamen continuo y admisión inmediata de errores.',
  'working_steps.desc.11':
    'Desarrollar prácticas espirituales y buscar guía mediante la oración y la meditación.',
  'working_steps.desc.12':
    'Compartir el mensaje de recuperación y vivir según principios espirituales en todas las áreas de la vida.',

  'working_steps.status.not_started': 'No iniciado',
  'working_steps.status.in_progress': 'En progreso',
  'working_steps.status.completed': 'Completado',
  'working_steps.card.step_label': 'Paso {n}',
  'working_steps.card.step_fallback': 'Paso',
  'working_steps.card.sign_in_prompt': 'Inicia sesión para seguir tu progreso',
  'working_steps.card.sign_in': 'Iniciar sesión',

  'working_steps.journey.loading': 'Cargando datos del recorrido…',
  'working_steps.journey.load_failed': 'No se pudieron cargar los datos del recorrido',
  'working_steps.journey.all_done':
    '¡Guau! ¡Felicidades por haber trabajado los 12 pasos de SAA!',
  'working_steps.journey.start_gs':
    '¡Tú puedes! Empieza con Primeros pasos abajo y luego comienza el Paso Uno.',
  'working_steps.journey.gs_in_progress':
    'Sigue con Primeros pasos — luego comienza el Paso Uno.',
  'working_steps.journey.gs_start': 'Empieza con Primeros pasos antes del Paso Uno.',
  'working_steps.journey.gs_done':
    '¡Buen trabajo en Primeros pasos! Haz clic en el Paso 1 abajo para empezar a trabajar los pasos.',
  'working_steps.journey.step12_partial':
    '¡Felicidades por completar el Paso 12! Has avanzado mucho. Para completar los 12 pasos, sigue trabajando los que aún no hayas terminado.',
  'working_steps.journey.step_done':
    '¡Felicidades por completar el Paso {n}! Sigue adelante. Haz clic en el Paso {next} abajo para continuar',
  'working_steps.journey.step_in_progress':
    'Estás avanzando muy bien — ¡sigue! Haz clic en el Paso {n} para continuar',
  'working_steps.journey.started': 'Has empezado a trabajar los 12 pasos. ¡Sigue adelante!',

  'working_steps.tab.label': 'Trabajar mis pasos',
  'working_steps.tab.title': 'Tu lista de los 12 Pasos de SAA',
  'working_steps.tab.login_title': 'Inicia sesión para seguir tu trabajo de 12 pasos',
  'working_steps.tab.login_body':
    'Crea una cuenta o inicia sesión para seguir tu progreso en los 12 pasos y recibir orientación personalizada en tu camino de recuperación.',
  'working_steps.tab.login_cta': 'Iniciar sesión / Crear cuenta',
  'working_steps.gs.label': 'Primeros pasos',
  'working_steps.gs.title':
    'Introducción a SAA — adicción, compañerismo, padrino y tus 3 Círculos',
  'working_steps.gs.description':
    'Lecturas, video y herramientas personales antes de comenzar el Paso Uno.',

  'step.1.page.nudge_lead': 'Recomendamos completar',
  'step.1.page.nudge_tail': 'antes de trabajar el Paso Uno.',
  'step.1.page.nudge_dismiss_aria': 'Descartar',
  'step.1.page.error.save_presentation': 'No se pudieron guardar las notas de presentación.',
  'step.1.page.error.save_writing': 'No se pudo guardar el progreso de escritura.',

  'step.1.presentation.date_label': 'Fecha en que lo presenté',
  'step.1.presentation.place_label': 'Lugar',
  'step.1.presentation.place_placeholder': 'p. ej. reunión del martes por la noche',
  'step.1.presentation.reflection_label': 'Cómo fue',
  'step.1.presentation.reflection_placeholder': 'Cómo te sentiste después de presentarlo',
  'step.1.presentation.target_date_label': 'Fecha prevista (opcional)',
  'step.1.presentation.venue_label': 'Dónde planeas compartirlo',
  'step.1.presentation.venue_select': '— Seleccionar —',
  'step.1.presentation.venue_note_label': 'Nota sobre el lugar',

  'step.1.mode.not_chosen': 'Aún sin elegir',
  'step.1.mode.external': 'Escrito y guardado en otro lugar',
  'step.1.mode.upload': 'Documento subido',
  'step.1.mode.typed': 'Escribirlo aquí',
  'step.1.mode.wizard': 'Recorrido guiado',
  'step.1.mode.fallback': 'Escritura del Primer Paso',

  'step.1.venue.workshop': 'Taller',
  'step.1.venue.home_meeting': 'Reunión base',
  'step.1.venue.sponsor_only': 'Solo con mi padrino',
  'step.1.venue.other': 'Otro',

  'step.1.progress.in_progress': 'en curso',
  'step.1.progress.started': 'iniciado',
  'step.1.progress.last_worked': 'última vez trabajado {date}',

  'step.1.length.word_one': '{count} palabra',
  'step.1.length.word_many': '{count} palabras',
  'step.1.length.aloud_one': '~{min} minuto al leerlo en voz alta',
  'step.1.length.aloud_many': '~{min} minutos al leerlo en voz alta',
  'step.1.length.aloud_range': '~{min}–{max} minutos al leerlo en voz alta',
  'step.1.length.summary': 'Longitud: {words} · {aloud}',

  'step.1.method.wizard.title': 'Recorrido guiado',
  'step.1.method.wizard.description':
    'Preguntas paso a paso y luego reúne tus palabras en un borrador.',
  'step.1.method.typed.title': 'Escribirlo aquí',
  'step.1.method.typed.description':
    'Editor de texto simple con guardado automático en Recovery Commons.',
  'step.1.method.upload.title': 'Subir un documento',
  'step.1.method.upload.description':
    'Formatos admitidos: .txt, .docx, .pdf, .md. Tamaño máximo: 5 MB. El archivo original se guarda cifrado.',
  'step.1.method.external.title': 'Escrito y guardado en otro lugar',
  'step.1.method.external.description':
    'Papel y lápiz, otra aplicación o ya terminado — sigue tu progreso aquí.',
  'step.1.method.fallback_title': 'Escritura del Primer Paso',

  'step.1.method_step.walkthrough.title': 'Tu historia',
  'step.1.method_step.walkthrough.body':
    'Responde cada pregunta de abajo lo mejor que puedas y luego haz clic en Siguiente. Haz clic en Omitir para las preguntas que no puedas responder, para las que no te sientas listo o que ya cubriste en una respuesta anterior. Estas preguntas te llevarán por todas las partes de una historia típica del Primer Paso. Descansa cuando quieras — tus respuestas se guardan y puedes continuar donde lo dejaste la próxima vez.',
  'step.1.method_step.assemble.title': 'Reúne tu borrador',
  'step.1.method_step.assemble.body':
    'Combina las respuestas de tu recorrido en un solo borrador — tus propias palabras, en orden.',
  'step.1.method_step.presentation.title': 'Plan de presentación',
  'step.1.method_step.presentation.body':
    'Define cuándo y dónde planeas compartirlo para ayudarte a prepararte con tu padrino.',
  'step.1.method_step.review.title': 'Revisar y compartir',
  'step.1.method_step.review.body':
    'Mantente en contacto con tu padrino y comparte la historia de tu Primer Paso para que la revise cuando necesites ayuda y antes de presentarla finalmente.',
  'step.1.method_step.your-story.title': 'Tu historia',
  'step.1.method_step.your-story.body':
    'Escribe tu historia abajo (usa Insertar plantilla si un esquema te ayuda).',
  'step.1.method_step.draft-checklist.title': 'Lista de revisión del borrador',
  'step.1.method_step.draft-checklist.body':
    'Recordatorios opcionales sobre temas comunes del Primer Paso — nunca cambiamos tu historia por ti.',
  'step.1.method_step.upload.title': 'Sube tu documento',
  'step.1.method_step.upload.body':
    'Sube tu documento (.txt, .docx, .pdf o .md — máximo 5 MB).',
  'step.1.method_step.review-edit.title': 'Revisar y editar',
  'step.1.method_step.review-edit.body':
    'Revisa y edita abajo el texto extraído si es necesario.',
  'step.1.method_step.where-kept.title': 'Dónde lo guardas',
  'step.1.method_step.where-kept.body':
    'Anota dónde guardas tu historia (opcional) — en papel, en otra aplicación, con tu padrino, etc.',

  'step.1.chapters.ch1': 'Introducción',
  'step.1.chapters.ch2': 'Familia y primeros años',
  'step.1.chapters.ch3': 'Cómo se desarrolló la adicción',
  'step.1.chapters.ch4': 'Impotencia',
  'step.1.chapters.ch5': 'Ingobernabilidad',
  'step.1.chapters.ch6': 'Tocar fondo y recuperación',
  'step.1.chapters.ch7': 'Cierre',

  'step.1.topics.introduction': 'Introducción (nombre, comunidad)',
  'step.1.topics.family_origin': 'Familia de origen',
  'step.1.topics.childhood_sexuality': 'Sexualidad en la infancia / primeras experiencias',
  'step.1.topics.addiction_development': 'Cómo se desarrolló la adicción',
  'step.1.topics.acting_out_patterns': 'Patrones de conducta compulsiva',
  'step.1.topics.powerlessness': 'Impotencia (no podía parar)',
  'step.1.topics.failed_stops': 'Intentos fallidos de parar',
  'step.1.topics.unmanageability': 'Ingobernabilidad',
  'step.1.topics.relationships_impact': 'Impacto en las relaciones',
  'step.1.topics.consequences': 'Consecuencias (trabajo, legales, salud)',
  'step.1.topics.bottom': 'Fondo / punto de inflexión',
  'step.1.topics.recovery_start': 'Cómo comenzó la recuperación',
  'step.1.topics.closing': 'Cierre (nombre, comunidad)',

  'step.1.prompts.intro_name.text':
    '¿Cómo te presentarás al comienzo de tu Primer Paso?',
  'step.1.prompts.intro_name.placeholder': 'Me llamo… y soy adicto sexual.',
  'step.1.prompts.family_overview.text': 'Describe tus primeros años mientras crecías',
  'step.1.prompts.family_overview.nudge':
    '¿Cómo era tu familia, cómo era tu relación con tus padres y hermanos, tenías amigos, se mudaban mucho, etc.?',
  'step.1.prompts.family_overview.placeholder':
    'Crecí en una familia donde… (vida en casa, padres, hermanos, amigos, mudanzas)',
  'step.1.prompts.family_sex_attitudes.text':
    '¿Qué aprendiste sobre el sexo, la vergüenza y el secreto mientras crecías?',
  'step.1.prompts.family_sex_attitudes.nudge':
    '¿Cuándo y cómo te presentaron el sexo, qué sentías sobre el sexo, alguien te explicó de dónde vienen los bebés, sufriste algún abuso que afectara tu visión del sexo, qué otros recuerdos fuertes sobre el sexo tienes de tu infancia, etc.?',
  'step.1.prompts.family_sex_attitudes.placeholder':
    'Mientras crecía, aprendí que el sexo era… / Los mensajes sobre el sexo y el secreto eran…',
  'step.1.prompts.addiction_start.text':
    '¿Cuándo notaste por primera vez una conducta sexual compulsiva? ¿Qué pasaba en tu vida entonces?',
  'step.1.prompts.addiction_start.placeholder':
    'Noté por primera vez que mi conducta sexual era compulsiva cuando… (edad, situación de vida)',
  'step.1.prompts.progression.text':
    '¿Cómo se intensificó tu conducta compulsiva con el tiempo? ¿Qué conductas aumentaron en frecuencia o intensidad?',
  'step.1.prompts.progression.placeholder':
    'Con el tiempo, mi conducta compulsiva pasó de… a… (frecuencia, intensidad, conductas nuevas)',
  'step.1.prompts.acting_out_examples.text':
    '¿Cuáles son o fueron tus principales conductas compulsivas? Para cada una, cuenta qué las precedía, qué ocurrió en lenguaje sencillo y cómo te sentiste antes y después.',
  'step.1.prompts.acting_out_examples.nudge':
    'Sin detalles sexuales explícitos. No menciones personas, lugares, sitios web ni aplicaciones concretas.',
  'step.1.prompts.acting_out_examples.placeholder':
    'Si tienes más de un tipo de conducta compulsiva, describe cada una por separado.',
  'step.1.prompts.powerlessness_moment.text':
    'Describe ocasiones en las que intentaste parar o controlar tu conducta y no pudiste — ¿qué pasó y cómo te sentiste?',
  'step.1.prompts.powerlessness_moment.nudge':
    'Impotencia significa que no podías parar por tu cuenta, incluso cuando querías.',
  'step.1.prompts.powerlessness_moment.placeholder':
    'Una vez intenté parar o controlar mi conducta haciendo… pero no pude porque…',
  'step.1.prompts.failed_stops.text':
    '¿Qué promesas te hiciste a ti mismo o a otros sobre parar? ¿Qué pasó cuando lo intentaste?',
  'step.1.prompts.failed_stops.placeholder':
    'Me prometí a mí mismo (o a alguien más) que pararía cuando… En cambio, lo que pasó fue…',
  'step.1.prompts.unmanageability_overview.text':
    '¿En qué áreas de tu vida creó tu adicción caos o daño?',
  'step.1.prompts.unmanageability_overview.nudge':
    'Piensa en las relaciones, el trabajo, las finanzas, la salud, la espiritualidad, el amor propio, la esperanza, etc.',
  'step.1.prompts.unmanageability_overview.placeholder':
    'Mi adicción creó caos en… (p. ej. relaciones, trabajo, dinero, salud, amor propio, esperanza)',
  'step.1.prompts.relationships.text': '¿Cómo afectó tu adicción a tus relaciones más cercanas?',
  'step.1.prompts.relationships.placeholder':
    'Mis relaciones más cercanas se vieron afectadas cuando yo… (mentiras, distancia, confianza rota, etc.)',
  'step.1.prompts.consequences.text':
    '¿Qué consecuencias concretas enfrentaste — relaciones perdidas, divorcios, pérdida de trabajo, problemas legales, problemas de salud u otros costos?',
  'step.1.prompts.consequences.placeholder':
    'Los costos concretos que enfrenté incluyeron… (p. ej. una relación, un trabajo, problemas legales, la salud)',
  'step.1.prompts.recent_episode.text':
    'Describe tu último episodio significativo de conducta compulsiva, cómo te hizo sentir y sus consecuencias',
  'step.1.prompts.recent_episode.placeholder':
    'Mi último episodio significativo: qué lo precedió, qué ocurrió en lenguaje sencillo, cómo me sentí después…',
  'step.1.prompts.feelings.text':
    '¿Qué sentimientos tenías sobre ti mismo y sobre tu vida en tu peor momento?',
  'step.1.prompts.feelings.placeholder':
    'En mi peor momento, sentía… sobre mí mismo, mi vida y las personas a mi alrededor.',
  'step.1.prompts.bottom.text':
    '¿Cuál fue tu fondo — el momento o período en que supiste que no podías seguir así?',
  'step.1.prompts.bottom.placeholder':
    'Mi fondo fue cuando me di cuenta de que no podía seguir así — p. ej. una crisis o un momento de desesperación…',
  'step.1.prompts.recovery_start.text': '¿Cómo encontraste SAA o empezaste a trabajar tu recuperación?',
  'step.1.prompts.recovery_start.placeholder':
    'Encontré SAA / empecé mi recuperación cuando… (cómo llegaste aquí, primera reunión, padrino, etc.)',
  'step.1.prompts.closing.text': '¿Cómo cerrarás tu Primer Paso?',
  'step.1.prompts.closing.placeholder':
    'Me llamo… y soy adicto sexual — y esa es mi historia, hasta ahora.',

  'step.1.checklist.introduction.feedback':
    'Muchos Primeros Pasos comienzan con tu nombre de pila y diciendo que eres adicto sexual.',
  'step.1.checklist.introduction.recommendation':
    'Agrégalo al principio si encaja con cómo quieres compartir.',
  'step.1.checklist.powerlessness.feedback':
    'Incluye una ocasión en la que intentaste parar o controlar tu conducta y no pudiste.',
  'step.1.checklist.powerlessness.recommendation':
    'Un ejemplo claro es suficiente — eso es el corazón del Paso Uno.',
  'step.1.checklist.unmanageability.feedback':
    'Cuenta cómo la adicción dañó partes de tu vida — relaciones, trabajo, dinero, salud o amor propio.',
  'step.1.checklist.unmanageability.recommendation': 'Uno o dos ejemplos son suficientes.',
  'step.1.checklist.length.feedback':
    'Tu borrador es corto ({count} palabras) — está bien mientras empiezas.',
  'step.1.checklist.length.recommendation':
    'Agrega más detalle donde te sientas listo.',
  'step.1.checklist.length_long.feedback':
    'Tu borrador tiene alrededor de {count} palabras — {aloud}.',
  'step.1.checklist.length_long.recommendation':
    'Puedes acortarlo más adelante si quieres; nada cambia a menos que tú lo edites.',

  'step.1.writing.close': 'Cerrar',
  'step.1.writing.cancel': 'Cancelar',
  'step.1.writing.continue': 'Continuar',
  'step.1.writing.save': 'Guardar',
  'step.1.writing.dismiss': 'Descartar',
  'step.1.writing.loading': 'Cargando tu trabajo guardado…',
  'step.1.writing.try_again': 'Intentar de nuevo',
  'step.1.writing.starting': 'Comenzando…',
  'step.1.writing.start_new_draft': 'Comenzar un borrador nuevo',
  'step.1.writing.view_earlier_saves': 'Ver guardados anteriores',
  'step.1.writing.encryption_reminder':
    'Recuerda: el texto de tu historia y los archivos subidos están cifrados en Recovery Commons. Los resúmenes de progreso que compartes nunca incluyen el texto de tu historia.',

  'step.1.writing.error.decrypt':
    'No pudimos descifrar esta copia de tu Primer Paso — se guardó con una clave de cifrado antigua. El trabajo de otras personas no se ve afectado. Puedes comenzar un borrador nuevo; eso solo reemplaza esta copia ilegible de tu cuenta.',
  'step.1.writing.error.auth': '{message} Después abre de nuevo el espacio de escritura.',
  'step.1.writing.error.load_with_local':
    'No pudimos cargar tu historia desde Recovery Commons. Puede que aún tengas una copia guardada en este teléfono o computadora.',
  'step.1.writing.error.load_generic':
    'No pudimos cargar tu trabajo guardado. No se borró nada en el servidor — inténtalo de nuevo o actualiza la página. Si acabas de cambiar de cuenta, cierra sesión, actualiza y vuelve a entrar.',
  'step.1.writing.error.reload_failed':
    'No se pudo recargar tu trabajo guardado. Intenta actualizar la página.',
  'step.1.writing.error.start_fresh_failed':
    'No se pudo comenzar un borrador nuevo. Inténtalo de nuevo.',

  'step.1.writing.protected_title': 'Tu trabajo fue protegido',
  'step.1.writing.protected_message':
    'Se detuvo un guardado porque habría borrado tu historia. Tu última copia buena sigue a salvo.',
  'step.1.writing.protected_ok': 'Aceptar',
  'step.1.writing.save_failed_title': 'No se pudo guardar',
  'step.1.writing.save_verify_failed':
    'No se pudo verificar tu trabajo guardado antes de guardar. Inténtalo de nuevo.',

  'step.1.writing.restore_success':
    'Se restauró un guardado anterior. Tu texto previo se conservó como otro guardado.',
  'step.1.writing.restore_confirm_title': '¿Usar este guardado anterior?',
  'step.1.writing.restore_confirm_archive':
    '¿Restaurar tu historia desde {label}? Tu texto actual se conserva como otro guardado.',
  'step.1.writing.restore_confirm_local':
    '¿Restaurar la copia guardada en este teléfono o computadora el {savedAt}? Tu texto actual se conserva como otro guardado.',
  'step.1.writing.restore_confirm_ok': 'Usar este guardado',
  'step.1.writing.restore_failed': 'No se pudo restaurar ese guardado. Inténtalo de nuevo.',
  'step.1.writing.no_local_save': 'No se encontró ningún guardado en este teléfono o computadora.',

  'step.1.writing.method_label': 'Método:',
  'step.1.writing.change_method': 'Cambiar método',
  'step.1.writing.change_method_title': '¿Cambiar el método de escritura?',
  'step.1.writing.change_method_message':
    'Tus respuestas del recorrido y tu borrador se conservan. Tu trabajo actual se guarda primero. ¿Continuar?',
  'step.1.writing.return_chooser_title': '¿Cambiar de método?',
  'step.1.writing.return_chooser_message':
    'Tu trabajo se conserva. Tu trabajo actual se guarda primero. ¿Continuar al selector de método?',

  'step.1.writing.path_picker_title': '¿Cómo te gustaría escribir la historia de tu Primer Paso?',
  'step.1.writing.path_picker_intro':
    'Elige un enfoque para empezar. Puedes cambiarlo después — tu trabajo guardado se conserva en Recovery Commons.',

  'step.1.writing.external_note_label': 'Dónde lo guardo (opcional)',
  'step.1.writing.external_note_placeholder':
    'p. ej. un diario en casa, un Google Doc, mi padrino tiene una copia',

  'step.1.writing.insert_template': 'Insertar plantilla',
  'step.1.writing.insert_template_title': '¿Insertar la plantilla?',
  'step.1.writing.insert_template_message':
    'Esto reemplaza el texto actual de tu historia con la plantilla de esquema. Tu trabajo actual se guarda primero.',
  'step.1.writing.story_aria': 'Historia del Primer Paso',
  'step.1.writing.story_placeholder': 'Escribe aquí la historia de tu Primer Paso…',
  'step.1.writing.section_your_story': 'Tu historia',

  'step.1.writing.upload_choose': 'Elige un archivo para subir',
  'step.1.writing.choose_file': 'Elegir archivo',
  'step.1.writing.no_file_chosen': 'Ningún archivo elegido',
  'step.1.writing.upload_file_label': 'Archivo:',
  'step.1.writing.download_original': 'Descargar el original',
  'step.1.writing.upload_failed': 'No se pudo subir el archivo',
  'step.1.writing.upload_replace_title': '¿Reemplazar con el archivo subido?',
  'step.1.writing.upload_replace_message':
    'Esto reemplaza el texto actual de tu historia con el documento subido. Tu trabajo actual se guarda primero.',
  'step.1.writing.upload_replace_ok': 'Subir y reemplazar',
  'step.1.writing.extracted_aria': 'Texto extraído de la historia',
  'step.1.writing.section_extracted': 'Historia extraída',

  'step.1.writing.jump_to_section': 'Ir a la sección:',
  'step.1.writing.chapter_optional_suffix': ' (opcional)',
  'step.1.writing.prompt_label': 'Pregunta',
  'step.1.writing.prompt_of': 'de',
  'step.1.writing.previous': 'Anterior',
  'step.1.writing.next': 'Siguiente',
  'step.1.writing.skip': 'Omitir',

  'step.1.writing.assembling': 'Reuniendo…',
  'step.1.writing.assemble_cta': 'Reunir mis palabras',
  'step.1.writing.assemble_stale_note':
    'Has cambiado una o más respuestas del recorrido desde que se reunió este borrador.',
  'step.1.writing.updating_draft': 'Actualizando el borrador…',
  'step.1.writing.update_draft_cta': 'Actualizar el borrador con mis respuestas',
  'step.1.writing.draft_current_note':
    'Tu borrador reunido ({words}) coincide con tus respuestas actuales del recorrido.',
  'step.1.writing.no_answers_yet': 'Agrega primero algunas respuestas del recorrido.',
  'step.1.writing.update_draft_title': '¿Actualizar el borrador reunido?',
  'step.1.writing.update_draft_message':
    'Esto reemplaza tu borrador reunido con una versión nueva hecha con tus respuestas del recorrido. Se perderán las ediciones manuales del borrador. Tu trabajo actual se guarda primero.',
  'step.1.writing.update_draft_ok': 'Actualizar el borrador',
  'step.1.writing.assemble_title': '¿Reunir el borrador?',
  'step.1.writing.assemble_message':
    'Esto crea un borrador nuevo con tus respuestas del recorrido y reemplaza el texto actual de tu historia. Tu trabajo actual se guarda primero.',
  'step.1.writing.assemble_ok': 'Reunir',
  'step.1.writing.assembled_long':
    'Tus respuestas se reunieron en un borrador. Abre el editor de borrador cuando estés listo para revisarlo.',
  'step.1.writing.assembled_short': 'Tus respuestas se reunieron en el borrador de abajo.',
  'step.1.writing.assembled_aria': 'Borrador reunido del Primer Paso',
  'step.1.writing.section_assembled_current': 'Tu borrador reunido',
  'step.1.writing.section_assembled': 'Borrador reunido',

  'step.1.writing.draft_ready_lead': 'Tu borrador está listo —',
  'step.1.writing.draft_ready_tail': '. Usa el editor de borrador para leerlo o modificarlo.',
  'step.1.writing.open_draft_editor': 'Abrir el editor de borrador',
  'step.1.writing.draft_editor_title': 'Borrador de mi Primer Paso',
  'step.1.writing.draft_editor_close_aria': 'Cerrar el editor de borrador',
  'step.1.writing.unsaved_changes': 'Cambios sin guardar',
  'step.1.writing.discard_title': '¿Descartar los cambios?',
  'step.1.writing.discard_message':
    'Tienes ediciones sin guardar en tu borrador. ¿Descartarlas y cerrar el editor?',
  'step.1.writing.discard_ok': 'Descartar',
  'step.1.writing.keep_editing': 'Seguir editando',
  'step.1.writing.save_empty_title': '¿Guardar un borrador vacío?',
  'step.1.writing.save_empty_message':
    'Esto borrará el texto reunido de tu historia. Tus respuestas del recorrido se conservan salvo que las cambies por separado. Tu trabajo actual se guarda primero.',
  'step.1.writing.save_empty_ok': 'Guardar borrador vacío',

  'step.1.writing.checklist_hint':
    'Recordatorios opcionales — toma lo que te sirva e ignora el resto. Nunca cambiamos tu historia por ti. Son recordatorios sencillos, no una revisión automática de tu escritura.',
  'step.1.writing.checklist_aria': 'Lista de revisión del borrador',
  'step.1.writing.checklist_consider': 'Considera:',

  'step.1.writing.view': 'Ver',
  'step.1.writing.download': 'Descargar',
  'step.1.writing.print': 'Imprimir',
  'step.1.writing.share_story': 'Compartir la historia de mi Primer Paso',
  'step.1.writing.share_confirm_message':
    'Esto crea un enlace con el texto completo de tu historia. Caduca en 3 días. Compártelo solo con personas de tu confianza (por ejemplo, tu padrino).',
  'step.1.writing.share_empty': 'Agrega el texto de tu historia antes de compartir.',
  'step.1.writing.my_first_step': 'Mi Primer Paso',

  'step.1.writing.download_title': 'Descargar Mi Primer Paso',
  'step.1.writing.download_intro': 'Elige un formato para guardarlo en tu dispositivo.',
  'step.1.writing.download_pdf': 'PDF (.pdf)',
  'step.1.writing.download_docx': 'Documento de Word (.docx)',
  'step.1.writing.download_txt': 'Texto sin formato (.txt)',
  'step.1.writing.download_failed': 'La descarga falló. Inténtalo de nuevo.',

  'step.1.writing.clear_title': 'Borrar todo el contenido del Primer Paso',
  'step.1.writing.clear_body_1':
    'Esto elimina de forma permanente de Recovery Commons la historia de tu Primer Paso, tus respuestas del recorrido, el documento subido y tu plan de presentación.',
  'step.1.writing.clear_body_2':
    'Guarda una copia en un lugar que controles antes de continuar — por ejemplo en tu computadora, en tu correo o con tu padrino.',
  'step.1.writing.clear_ack':
    'He guardado una copia fuera de Recovery Commons (o no necesito una).',
  'step.1.writing.clearing': 'Borrando…',
  'step.1.writing.clear_footer_link': 'Borrar el contenido del Primer Paso (requiere confirmación)',
  'step.1.writing.clear_success': 'Se borró el contenido de tu Primer Paso.',
  'step.1.writing.clear_failed': 'No se pudo borrar tu contenido. Inténtalo de nuevo.',

  'step.1.writing.missing_story':
    'Tu historia parece vacía aquí, pero encontramos guardados anteriores. ¿Quieres verlos?',
  'step.1.writing.saving': 'Guardando…',
  'step.1.writing.saved': 'Guardado',
  'step.1.writing.save_error': 'No se pudo guardar — vuelve a intentarlo editando',
  'step.1.writing.something_missing': '¿Falta algo? Ver guardados anteriores',

  'step.1.writing.template': `Me llamo ______ y soy adicto sexual. Esta es la historia de mi adicción, de mi incapacidad para controlarla por mi cuenta y de la ingobernabilidad que ha causado en mi vida.

[Familia de origen y primeras experiencias — cómo mi crianza se relacionó con la vergüenza, la validación o el secreto en torno al sexo]

[Cómo se desarrolló mi adicción — su progresión con el tiempo]

[Ejemplos de impotencia — veces en que intenté parar y no pude]

[Ejemplos de ingobernabilidad — impacto en las relaciones, el trabajo, las finanzas, la salud, el espíritu]

[Opcional: mi fondo y cómo encontré la recuperación]

Me llamo ______ y soy adicto sexual — y esa es mi historia, hasta ahora.`,

  'step.1.recover.title': 'Guardados anteriores de tu historia',
  'step.1.recover.intro':
    'Recovery Commons conserva guardados anteriores mientras trabajas. Si restauras uno, tu historia actual se conserva como otro guardado — nada se desecha.',
  'step.1.recover.local_heading': 'Guardado en este teléfono o computadora',
  'step.1.recover.use_local': 'Usar el guardado del {date}',
  'step.1.recover.server_heading': 'Guardados anteriores en Recovery Commons',
  'step.1.recover.loading': 'Cargando guardados anteriores…',
  'step.1.recover.empty':
    'Aún no hay guardados anteriores. Se crean automáticamente mientras trabajas.',
  'step.1.recover.use_this': 'Usar este guardado',

  // ===== BEGIN step.4.inventory.* — Inventarios del Cuarto Paso =====
  // Ventana modal
  'step.4.inventory.modal_title': 'Inventarios del Cuarto Paso',
  'step.4.inventory.close': 'Cerrar',
  'step.4.inventory.header_title': 'Inventario de {type}',
  'step.4.inventory.completed_checkbox': 'Inventario completado',
  'step.4.inventory.completed_checkbox_for_type': 'He completado mi inventario de {type}',
  'step.4.inventory.mobile.progress': '{done} de {total} inventarios marcados como completos',
  'step.4.inventory.mobile.complete_when_empty':
    'Agrega al menos un elemento a este inventario primero.',
  'step.4.inventory.add_to_list': 'Agregar a la lista',
  'step.4.inventory.counts': '({total} en total, {complete} completados)',
  'step.4.inventory.saving': 'Guardando…',
  'step.4.inventory.saved': 'Guardado',
  'step.4.inventory.save_failed_badge': 'No se pudo guardar',
  'step.4.inventory.click_for_details': 'haz clic para ver/agregar detalles',
  'step.4.inventory.delete': 'Eliminar',
  'step.4.inventory.help_inventories_title': 'Obtener ayuda con los inventarios',
  'step.4.inventory.help_field_title': 'Obtener ayuda con este campo',
  'step.4.inventory.help_dialog_title': 'Ayuda',
  'step.4.inventory.help_unavailable':
    '<h3>Ayuda</h3><p>El contenido de ayuda no está disponible.</p>',
  'step.4.inventory.help_unavailable_field':
    'El contenido de ayuda no está disponible para este campo.',

  // Tipos de inventario
  'step.4.inventory.type.resentments': 'Resentimientos',
  'step.4.inventory.type.fears': 'Temores',
  'step.4.inventory.type.harms': 'Daños causados',
  'step.4.inventory.my.resentments': 'Mis resentimientos',
  'step.4.inventory.my.fears': 'Mis temores',
  'step.4.inventory.my.harms': 'Los daños que causé',

  // Estado
  'step.4.inventory.status.not_started': 'sin comenzar',
  'step.4.inventory.status.completed': 'completado ({count})',
  'step.4.inventory.status.in_progress': 'en progreso ({count})',

  // Agregar entradas
  'step.4.inventory.entry.resentments.label': '¿A quién le guardo resentimiento?',
  'step.4.inventory.entry.resentments.placeholder':
    'p. ej., Mi hermana Julia, Mi jefe, El gobierno…',
  'step.4.inventory.entry.resentments.welcome':
    'Comienza agregando arriba tu primer resentimiento',
  'step.4.inventory.entry.fears.label': '¿A qué le temo?',
  'step.4.inventory.entry.fears.placeholder': 'p. ej., Miedo al rechazo, Miedo al fracaso…',
  'step.4.inventory.entry.fears.welcome': 'Comienza agregando arriba tu primer temor',
  'step.4.inventory.entry.harms.label': '¿A quién le hice daño?',
  'step.4.inventory.entry.harms.placeholder': 'p. ej., Mi esposa, Mis hijos, Mi amigo Juan…',
  'step.4.inventory.entry.harms.welcome': 'Comienza agregando arriba el primer daño',

  // Casillas de impacto
  'step.4.inventory.impact.self_esteem': 'Autoestima',
  'step.4.inventory.impact.pride': 'Orgullo',
  'step.4.inventory.impact.pocketbook': 'Bolsillo',
  'step.4.inventory.impact.personal_relationships': 'Relaciones personales',
  'step.4.inventory.impact.sexual_relationships': 'Relaciones sexuales',
  'step.4.inventory.impact.emotional_security': 'Seguridad emocional',
  'step.4.inventory.impact.ambitions': 'Ambiciones',

  // Casillas de defectos de carácter
  'step.4.inventory.defect.controlling': 'Controlador',
  'step.4.inventory.defect.dishonest': 'Deshonesto',
  'step.4.inventory.defect.disengaged': 'Desentendido',
  'step.4.inventory.defect.entitled': 'Con sentido de derecho',
  'step.4.inventory.defect.frightened': 'Temeroso',
  'step.4.inventory.defect.greedy': 'Codicioso',
  'step.4.inventory.defect.inconsiderate': 'Desconsiderado',
  'step.4.inventory.defect.impulsive': 'Impulsivo',
  'step.4.inventory.defect.lustful': 'Lujurioso',
  'step.4.inventory.defect.self_pity': 'Autocompasivo',
  'step.4.inventory.defect.selfish': 'Egoísta',
  'step.4.inventory.defect.willful': 'Obstinado',

  // Campos de detalle — resentimientos
  'step.4.inventory.field.who.label': '¿A quién le guardo resentimiento?',
  'step.4.inventory.field.who.placeholder': 'Quién',
  'step.4.inventory.field.why.label': '¿Por qué le guardo resentimiento?',
  'step.4.inventory.field.why.placeholder': '¿Qué pasó? ¿Qué hizo esa persona?',
  'step.4.inventory.field.feeling.label': '¿Cómo me hizo sentir eso?',
  'step.4.inventory.field.feeling.placeholder':
    'p. ej., con ira, herido, traicionado, avergonzado…',
  'step.4.inventory.field.impact.label': '¿Qué perdí, me quitaron o sentí amenazado dentro de mí?',
  'step.4.inventory.field.my_part.label': '¿Cuál fue mi parte en este resentimiento?',
  'step.4.inventory.field.my_part.placeholder':
    'Sé honesto sobre tu papel, aunque sea pequeño…',

  // Campos de detalle — temores
  'step.4.inventory.field.fear.label': '¿A qué le temo?',
  'step.4.inventory.field.fear.placeholder': 'Temor',
  'step.4.inventory.field.fear_why.label': '¿Por qué tengo este temor?',
  'step.4.inventory.field.fear_why.placeholder': '¿Qué hay detrás de este temor? ¿Qué lo causó?',
  'step.4.inventory.field.fear_impact.label': '¿Cómo me afecta este temor?',

  // Campos de detalle — daños
  'step.4.inventory.field.who_harmed.label': '¿A quién le hice daño?',
  'step.4.inventory.field.who_harmed.placeholder': 'A quién dañé',
  'step.4.inventory.field.how.label': '¿Cómo le hice daño?',
  'step.4.inventory.field.how.placeholder': '¿Qué hiciste que le causó daño?',
  'step.4.inventory.field.defects.label': '¿Qué parte de mi carácter causó este daño?',
  'step.4.inventory.field.alternative.label': '¿Qué podría haber hecho de otra manera?',
  'step.4.inventory.field.alternative.placeholder': '¿Cuál habría sido una mejor decisión?',

  // Diálogos
  'step.4.inventory.dialog.ok': 'Aceptar',
  'step.4.inventory.dialog.this_entry': 'esta entrada',
  'step.4.inventory.dialog.session_expired_title': 'Sesión expirada',
  'step.4.inventory.dialog.session_expired_changes':
    'Tu sesión expiró. Cierra sesión y vuelve a iniciarla para seguir guardando los cambios.',
  'step.4.inventory.dialog.session_expired_entries':
    'Tu sesión expiró. Cierra sesión y vuelve a iniciarla para seguir guardando las entradas.',
  'step.4.inventory.dialog.not_logged_in_title': 'No has iniciado sesión',
  'step.4.inventory.dialog.not_logged_in_message':
    'Inicia sesión para guardar las entradas del inventario.',
  'step.4.inventory.dialog.encryption_error_title': 'Error de cifrado',
  'step.4.inventory.dialog.encryption_error_message':
    'No se pudieron cifrar tus datos. Intenta actualizar la página. Si el problema continúa, cierra sesión y vuelve a iniciarla.',
  'step.4.inventory.dialog.network_error_title': 'Error de red',
  'step.4.inventory.dialog.network_error_message':
    'No se pudo guardar. Revisa tu conexión a internet e inténtalo de nuevo.',
  'step.4.inventory.dialog.save_failed_title': 'No se pudo guardar',
  'step.4.inventory.dialog.save_failed_message':
    'No se pudo guardar esta entrada. Inténtalo de nuevo. Si el problema continúa, actualiza la página.',
  'step.4.inventory.dialog.close_unsaved':
    'No se pudieron guardar tus cambios. Si cierras ahora, perderás tu trabajo reciente. ¿Quieres intentarlo de nuevo o cerrar de todos modos?',
  'step.4.inventory.dialog.close_anyway': 'Cerrar de todos modos',
  'step.4.inventory.dialog.try_again': 'Intentar de nuevo',
  'step.4.inventory.dialog.collapse_save_warning':
    'Advertencia: no se pudieron guardar tus cambios. Intenta editar de nuevo o revisa tu conexión.',
  'step.4.inventory.dialog.delete_confirm': '¿Seguro que quieres eliminar «{name}»?',
  'step.4.inventory.dialog.start_over_confirm':
    '¿Seguro que quieres borrar tu inventario de {type}? Todas tus entradas se eliminarán de forma permanente. Asegúrate de haber descargado tu inventario actual si quieres conservar una copia.',
  'step.4.inventory.dialog.no_entries_download':
    'No hay entradas para descargar en este inventario.',
  'step.4.inventory.dialog.download_success':
    'Se descargaron correctamente {count} entradas cifradas de {type}.',
  'step.4.inventory.dialog.download_failed':
    'No se pudo descargar el inventario. Inténtalo de nuevo.',
  'step.4.inventory.dialog.incomplete_entries':
    'Hay entradas incompletas en tu inventario.',

  // Descarga / carga de archivos
  'step.4.inventory.file.encrypted_file': 'Archivo de inventario cifrado',
  'step.4.inventory.file.encrypted_files': 'Archivos de inventario cifrados',
  'step.4.inventory.upload.no_file': 'No se seleccionó ningún archivo',
  'step.4.inventory.upload.not_json':
    'Error: selecciona un archivo JSON exportado desde Recovery Commons.',
  'step.4.inventory.upload.reading': 'Leyendo y descifrando el archivo…',
  'step.4.inventory.upload.invalid_format':
    'Formato de archivo no válido. Usa un archivo exportado desde Recovery Commons.',
  'step.4.inventory.upload.type_mismatch':
    'Este archivo contiene datos de {fileType}, pero estás intentando cargarlo en {currentType}. Cambia a la pestaña de inventario correcta.',
  'step.4.inventory.upload.no_data': 'No se encontraron datos válidos en el archivo.',
  'step.4.inventory.upload.save_failed':
    'No se pudieron guardar en tu cuenta los datos importados.',
  'step.4.inventory.upload.success': 'Se cargaron correctamente {count} entradas.',
  'step.4.inventory.upload.failed': 'Error al cargar: {error}',
  'step.4.inventory.upload.unknown_error': 'Ocurrió un error desconocido al cargar el archivo.',

  // Página del Cuarto Paso — programar el Quinto Paso
  'step.4.inventory.schedule.title': 'Programar el Quinto Paso con mi padrino',
  'step.4.inventory.schedule.subtext': '(mientras sigo trabajando en mis inventarios)',
  'step.4.inventory.schedule.scheduled_full': 'Ya acordé una fecha y una hora',
  'step.4.inventory.schedule.scheduled_short': 'Fecha y hora acordadas',
  'step.4.inventory.schedule.place_full':
    'Ya elegí un lugar para reunirnos (en persona o en línea)',
  'step.4.inventory.schedule.place_short': 'Lugar de reunión elegido',

  // Página del Cuarto Paso — aviso de validación
  'step.4.inventory.validation.title': 'Acción incompleta',
  'step.4.inventory.validation.action3':
    'Debes completar los tres inventarios (Resentimientos, Temores y Daños causados) y marcar ambas casillas de programación para dar por completada esta acción.',
  'step.4.inventory.validation.scheduling':
    'Marca ambas casillas para confirmar que acordaste una fecha y una hora y que elegiste un lugar específico.',
  'step.4.inventory.validation.ok': 'Aceptar',

  // Contenido del panel de ayuda (se muestra como HTML en el diálogo de ayuda)
  'step.4.inventory.help.inventory': `
        <h2>🧾 Cómo completar tus inventarios del Paso 4</h2>
        <p>Esta herramienta te ayuda a trabajar los <strong>tres inventarios del Paso 4</strong>:</p>
        <ul>
            <li><strong>Resentimientos</strong></li>
            <li><strong>Temores</strong></li>
            <li><strong>Daños causados a otras personas</strong></li>
        </ul>
        <p>Usa las <strong>pestañas de arriba</strong> para cambiar entre ellos. A medida que avances, cada pestaña mostrará tu estado de avance.</p>

        <h3>🪪 Para empezar</h3>
        <p>En cada inventario:</p>
        <ol>
            <li><strong>Agrega entradas rápidamente</strong> — escribe los nombres (o los temores) uno por uno y presiona <strong>Entrar</strong> o haz clic en <strong>«Agregar a la lista».</strong></li>
            <li><strong>Haz clic en cualquier entrada para agregar detalles</strong> — la entrada se expande y muestra campos editables. Complétalos y avanza con el tabulador.</li>
            <li><strong>Los cambios se guardan automáticamente</strong> — cuando sales de un campo o cierras una entrada, tu trabajo queda guardado.</li>
        </ol>
        <p>Cuando hayas completado todos los detalles de una entrada, verás una marca ✅ junto a ella. Las entradas incompletas dirán <em>«haz clic para ver/agregar detalles».</em></p>
        <p>Una vez que termines todas las entradas de un inventario, marca la casilla <strong>«Inventario completado»</strong> de arriba — la pestaña se actualizará para mostrar que está completo.</p>
        <blockquote>
            💡 Cuando los tres inventarios estén completos, podrás marcar esta acción como completada. Es un gran logro: completar estos inventarios es una de las partes más difíciles de trabajar los 12 pasos.
        </blockquote>

        <h3>❓ ¿Necesitas ayuda?</h3>
        <p>¿No estás seguro de lo que significa un campo?<br>
        Haz clic en el <strong>signo de interrogación azul (?)</strong> que está junto a él para ver una explicación breve.</p>
        <p>Tus respuestas se guardan automáticamente mientras trabajas, así que puedes cerrar el inventario en cualquier momento y volver más tarde.</p>

        <hr>

        <h3>📂 Administrar este inventario</h3>
        <p>Cada pestaña de inventario tiene tres botones en la parte superior:</p>
        <ul>
            <li><strong>Descargar</strong> – Guarda en tu dispositivo una <strong>copia de seguridad cifrada</strong> (.json) de este inventario. Tú eliges dónde guardarla y puedes cambiarle el nombre si quieres.</li>
            <li><strong>Cargar</strong> – Restaura un archivo de inventario cifrado que hayas descargado antes. Solo funciona con archivos descargados desde Recovery Commons.</li>
            <li><strong>Empezar de nuevo</strong> – Elimina de forma permanente todas las entradas de este inventario. Se te pedirá confirmación primero.</li>
        </ul>
        <blockquote>
            🔐 <strong>Seguridad y privacidad:</strong> los archivos descargados se cifran con tu clave de cifrado personal. Solo tú puedes descifrarlos y restaurarlos. Tu trabajo está seguro tanto en la nube como en tu dispositivo.
        </blockquote>
        <p><em>Nota: estos botones solo afectan a la pestaña de inventario que estás viendo — tus otros inventarios no cambian.</em></p>

        <hr>

        <h3>📤 Compartir con tu padrino</h3>
        <p>¿Quieres compartir tus inventarios del Cuarto Paso con tu padrino?</p>
        <p>Usa <strong>«Compartir con el padrino»</strong> en la página del Cuarto o del Quinto Paso — el resumen incluye tus inventarios completos.</p>
      `,
  'step.4.inventory.help.resentment_who': `
        <h3>¿A quién le guardo resentimiento?</h3>
        <p>En esta parte de mi trabajo del Cuarto Paso, simplemente hago una lista de <strong>a quién o a qué le guardo resentimiento</strong>.</p>
        <p>No analizo ni justifico: solo anoto los nombres o las cosas.</p>
        <p>Pienso de forma amplia:</p>
        <ul>
            <li><strong>Personas:</strong> familia, parejas, exparejas, amistades, yo mismo, jefes, maestros, la policía, el clero, padrinos.</li>
            <li><strong>Instituciones:</strong> el matrimonio, la iglesia, el gobierno, los sistemas legales o de salud mental.</li>
            <li><strong>Cosas o situaciones:</strong> la pornografía, las redes sociales, el alcohol, el dinero, mi trabajo, incluso mi teléfono.</li>
        </ul>
        <p>Este es solo el primer paso de mi inventario de resentimientos. Más adelante veré <strong>por qué les guardo resentimiento</strong>, <strong>cómo me afectó</strong> y <strong>cuál fue mi parte</strong>.</p>
        <p>Me mantengo honesto y sin miedo: esto es para mi sanación, y trabajaré los detalles en los pasos siguientes.</p>
      `,
  'step.4.inventory.help.resentment_why': `
        <h3>¿Por qué le guardo resentimiento?</h3>
        <p>En esta columna describo brevemente la experiencia o la conducta concreta que provocó mi resentimiento. Me limito a los hechos: no hace falta analizar de más ni profundizar en cómo me afectó emocionalmente.</p>
        <p><strong>Lo que hago:</strong></p>
        <ul>
            <li>Escribo una declaración clara y objetiva de lo que hicieron o de lo que pasó.</li>
            <li>Lo mantengo corto, como un resumen en una viñeta.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Me interrumpían todo el tiempo en las reuniones de trabajo».</li>
            <li>«La clínica canceló mi cita dos semanas seguidas».</li>
            <li>«Mi expareja publicó mis mensajes privados en internet».</li>
        </ul>
        <p>Eso es todo: directo y sencillo. Este paso me ayuda a enfocarme exactamente en por qué existe el resentimiento, y sienta las bases para explorarlo más a fondo después.</p>
      `,
  'step.4.inventory.help.resentment_feeling': `
        <h3>¿Cómo me hizo sentir eso?</h3>
        <p>En este campo nombro brevemente la emoción o las emociones que siento o sentí en relación con este resentimiento. Me centro en lo que sentí por dentro: ira, dolor, traición, decepción, etc. Se trata de captar mi reacción emocional.</p>
        <p><strong>Cómo lo hago:</strong></p>
        <ul>
            <li>Uso una o dos palabras que nombren la emoción, de forma directa y honesta.</li>
            <li>Lo mantengo corto: lo justo para expresar lo que realmente sentí.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Me sentí con ira y ninguneado».</li>
            <li>«avergonzado, herido»</li>
            <li>«me siento traicionado»</li>
        </ul>
      `,
  'step.4.inventory.help.resentment_impact': `
        <h3>¿Qué perdí, me quitaron o sentí amenazado dentro de mí?</h3>
        <p>Marco una o más áreas de mí mismo que resultaron afectadas por este resentimiento. Se refieren a mis <strong>partes, sentimientos o necesidades internas, no a pérdidas externas.</strong></p>
        <ul>
            <li><strong>Autoestima:</strong> mi sentido esencial de valor propio como persona.</li>
            <li><strong>Orgullo:</strong> cómo creo que me ven los demás, mi reputación o mi posición.</li>
            <li><strong>Bolsillo:</strong> mis pérdidas económicas o materiales: dinero, bienes, propiedades.</li>
            <li><strong>Relaciones personales:</strong> mis vínculos con los demás: amistades, lazos familiares, confianza.</li>
            <li><strong>Relaciones sexuales:</strong> mis vínculos íntimos o físicos: necesidades, confianza, cercanía.</li>
            <li><strong>Seguridad emocional:</strong> mi sensación interna de estabilidad: sentirme a salvo, en calma o apoyado emocionalmente.</li>
            <li><strong>Ambiciones:</strong> mis metas, esperanzas y sueños: carrera, crecimiento personal o planes a futuro.</li>
        </ul>
      `,
  'step.4.inventory.help.resentment_part': `
        <h3>¿Cuál fue mi parte en este resentimiento?</h3>
        <p>Examino con honestidad cómo mis propias actitudes o acciones contribuyeron a este resentimiento o lo prolongaron. No se trata de culparme, sino de asumir mi responsabilidad y encontrar oportunidades de crecimiento.</p>
        <p><strong>Me pregunto:</strong></p>
        <ul>
            <li>¿Estaba siendo egoísta o haciendo mi propia voluntad?</li>
            <li>¿Fui deshonesto conmigo mismo o con los demás?</li>
            <li>¿Tenía miedo, estaba a la defensiva o intentaba controlar la situación?</li>
            <li>¿Hice chismes, aparté a alguien o me negué a comunicarme?</li>
            <li>¿Podría haber manejado las cosas de otra manera?</li>
        </ul>
        <p><strong>Ejemplos de asumir mi parte:</strong></p>
        <ul>
            <li>«No dije nada cuando cruzaron mi límite: me lo guardé y luego me consumió la ira».</li>
            <li>«Los culpé en público e hice chismes en vez de hablar en privado».</li>
            <li>«Me negué a admitir que temía ser rechazado, así que ataqué primero».</li>
        </ul>
        <p>Ser honesto aquí me ayuda a ver el papel que jugué, para poder aprender y soltar. Es un paso poderoso hacia la sanación.</p>
      `,
  'step.4.inventory.help.fear_what': `
        <h3>¿A qué le temo?</h3>
        <p>Un <strong>inventario del Cuarto Paso</strong> —también llamado <em>inventario moral</em>— es un <strong>autoexamen escrito (o tecleado)</strong> que se usa en Adictos al Sexo Anónimos (SAA) para explorar con honestidad los pensamientos, sentimientos y conductas que impulsan la adicción. Abarca áreas clave como los resentimientos, los temores y los daños causados a otras personas.</p>
        <p>En esta parte de mi trabajo del Cuarto Paso, simplemente hago una lista de <strong>a qué le temo</strong>.</p>
        <p>No analizo ni justifico: solo anoto los temores.</p>
        <p>Pienso de forma amplia:</p>
        <ul>
            <li><strong>Personas:</strong> miedo al rechazo, miedo al abandono, miedo a la autoridad.</li>
            <li><strong>Situaciones:</strong> miedo al fracaso, miedo al éxito, miedo al cambio.</li>
            <li><strong>Sentimientos:</strong> miedo a las emociones, miedo a la intimidad, miedo a estar solo.</li>
        </ul>
        <p>Este es solo el primer paso de mi inventario de temores. Más adelante veré <strong>por qué les temo</strong>, <strong>cómo me afectó</strong> y <strong>cuál fue mi parte</strong>.</p>
        <p>Me mantengo honesto y sin miedo: esto es para mi sanación, y trabajaré los detalles en los pasos siguientes.</p>
      `,
  'step.4.inventory.help.fear_why': `
        <h3>¿Por qué tengo este temor?</h3>
        <p>En este campo indago en la razón real detrás de mi temor: qué creencia o preocupación lo impulsa. Busco la historia que mi mente me cuenta y que hace que este temor parezca cierto.</p>
        <p><strong>Cómo lo completo:</strong></p>
        <ul>
            <li>Me pregunto: ¿qué temo que pase? ¿Qué mentira estoy creyendo?</li>
            <li>Lo mantengo corto: unas pocas palabras o una frase sencilla.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Temo perder mi trabajo porque creo que no soy suficientemente bueno».</li>
            <li>«Temo estar solo porque creo que a nadie le importaré».</li>
            <li>«Temo fracasar porque ya he defraudado a otras personas».</li>
        </ul>
      `,
  'step.4.inventory.help.fear_impact': `
        <h3>¿Cómo me afecta este temor?</h3>
        <p>Selecciono una o más partes de mí que este temor toca: son mis sentimientos o necesidades internas que se sienten amenazadas.</p>
        <p><strong>Elijo las áreas a las que afecta:</strong></p>
        <ul>
            <li><strong>Autoestima:</strong> cómo me siento conmigo mismo, mi sentido de valor propio.</li>
            <li><strong>Orgullo:</strong> cómo creo que los demás me ven o me juzgan.</li>
            <li><strong>Bolsillo:</strong> mi sensación de seguridad económica o material.</li>
            <li><strong>Relaciones personales:</strong> la confianza, la cercanía y el apoyo en mis amistades o en mi familia.</li>
            <li><strong>Relaciones sexuales:</strong> mis vínculos íntimos y la confianza con otras personas.</li>
            <li><strong>Seguridad emocional:</strong> mi calma interior y mi sensación de estar a salvo.</li>
            <li><strong>Ambiciones:</strong> mis esperanzas, metas y sueños para el futuro.</li>
        </ul>
        <p><strong>Por qué importa:</strong></p>
        <p>Elegirlas me ayuda a ver qué partes de mí se sienten sacudidas por este temor, para saber dónde puedo necesitar apoyo o sanación.</p>
      `,
  'step.4.inventory.help.harm_who': `
        <h3>¿A quién le hice daño?</h3>
        <p>En este campo hago una lista de <strong>todas las personas a las que hice daño</strong>, ya sea con acciones grandes o pequeñas, por lo que hice o por lo que dejé de hacer. Incluyo a cualquiera que se haya visto afectado por mi conducta, directa o indirectamente.</p>
        <p><strong>Lo que hago:</strong></p>
        <ul>
            <li>Anoto los nombres de las personas a las que dañé: familia, amistades, parejas, compañeros de trabajo, conocidos o incluso personas que apenas conozco.</li>
            <li>También me incluyo a <strong>mí mismo</strong>, reconociendo que mis acciones o decisiones muchas veces también me han lastimado.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Mi cónyuge»</li>
            <li>«Mi hermana»</li>
            <li>«Mi compañero de trabajo Marcos»</li>
            <li>«Yo mismo»</li>
        </ul>
      `,
  'step.4.inventory.help.harm_how': `
        <h3>¿Cómo le hice daño?</h3>
        <p>En este campo describo brevemente <strong>lo que hice o dejé de hacer</strong> que causó daño. Me limito a los hechos y voy al grano: un resumen corto de mi acción u omisión.</p>
        <p><strong>Cómo lo completo:</strong></p>
        <ul>
            <li>Escribo exactamente lo que hice, sin excusas ni historias largas.</li>
            <li>Lo mantengo breve, como una viñeta.</li>
            <li>Puedo tener <strong>varias entradas para la misma persona</strong>, sobre todo con quienes me son más cercanos, porque puedo haberles hecho daño de distintas maneras.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Ignoré el mensaje de mi hermano cuando necesitaba ayuda».</li>
            <li>«Le mentí a mi pareja sobre dónde estaba».</li>
            <li>«Tomé dinero de mi compañero de cuarto sin pedírselo».</li>
        </ul>
        <p>Esto me ayuda a ver con claridad cómo he afectado a otras personas y me prepara para reparar el daño más adelante.</p>
      `,
  'step.4.inventory.help.harm_character': `
        <h3>¿Qué parte de mi carácter causó este daño?</h3>
        <p>Aquí observo <strong>qué partes de mi carácter contribuyeron al daño que causé</strong>. Selecciono una o más que correspondan. Ser honesto me ayuda a ver mis patrones y a asumir mi responsabilidad.</p>
        <p><strong>Qué significa cada una:</strong></p>
        <ul>
            <li><strong>Controlador:</strong> intenté forzar resultados o forzar a las personas a hacer lo que yo quería.</li>
            <li><strong>Deshonesto:</strong> no dije la verdad, oculté cosas o tergiversé los hechos.</li>
            <li><strong>Desentendido:</strong> me retiré, evité o descuidé a personas o situaciones.</li>
            <li><strong>Con sentido de derecho:</strong> creí que merecía un trato especial o que podía hacer lo que quisiera.</li>
            <li><strong>Temeroso:</strong> actué por miedo y dejé que guiara mis decisiones.</li>
            <li><strong>Codicioso:</strong> quise más de lo que me correspondía, ya fuera atención, cosas o experiencias.</li>
            <li><strong>Desconsiderado:</strong> no pensé en cómo mis acciones afectarían a los demás.</li>
            <li><strong>Impulsivo:</strong> actué sin pensar ni preocuparme por las consecuencias.</li>
            <li><strong>Lujurioso:</strong> usé a otras personas para satisfacer mis deseos sexuales sin consideración hacia ellas.</li>
            <li><strong>Autocompasivo:</strong> sentí lástima de mí mismo y lo usé para justificar acciones dañinas.</li>
            <li><strong>Egoísta:</strong> puse mis deseos y necesidades por encima de los de todos los demás.</li>
            <li><strong>Obstinado:</strong> seguí adelante con lo que yo quería, ignorando lo que era correcto o sensato.</li>
        </ul>
      `,
  'step.4.inventory.help.harm_alternative': `
        <h3>¿Qué podría haber hecho de otra manera?</h3>
        <p>En este campo reflexiono sobre <strong>cómo podría haber manejado mejor las cosas</strong>: acciones que podría haber tomado y que habrían causado menos daño o habrían resuelto la situación de forma más responsable.</p>
        <p><strong>Cómo lo completo:</strong></p>
        <ul>
            <li>Lo mantengo simple y constructivo.</li>
            <li>Me centro en alternativas reales y prácticas: lo que <em>podría</em> haber hecho en lugar de eso.</li>
        </ul>
        <p><strong>Ejemplos:</strong></p>
        <ul>
            <li>«Podría haber escuchado y buscado acercarme en vez de irme».</li>
            <li>«Podría haber sido honesto sobre dónde estaba».</li>
            <li>«Podría haber pedido permiso antes de usar el dinero de mi compañero de cuarto».</li>
        </ul>
        <p>Elegir estas alternativas me ayuda a ver cómo puedo crecer y cambiar en mis acciones futuras.</p>
      `,
  // ===== END step.4.inventory.* =====

  // ===== BEGIN step.5.* — Espacio de trabajo del Quinto Paso =====
  // Notas sobre la presentación del inventario (acción 3)
  'step.5.presentation.started_label': 'Fecha de inicio',
  'step.5.presentation.place_label': 'Lugar(es)',
  'step.5.presentation.place_placeholder':
    'p. ej., la casa de mi padrino, una cafetería o Zoom',
  'step.5.presentation.reflection_label': 'Cómo fue / cómo me siento',
  'step.5.presentation.reflection_placeholder': 'Cómo fue la experiencia',

  // Lista de defectos de carácter (acción 4)
  'step.5.defects.label': 'Mis defectos de carácter',
  'step.5.defects.examples_button': 'Ejemplos de defectos de carácter',
  'step.5.defects.first_placeholder': 'Escribe un defecto de carácter…',
  'step.5.defects.next_placeholder': 'Agrega otro defecto de carácter…',
  'step.5.examples.modal_title': 'Ejemplos de defectos de carácter / deficiencias',
  // ===== END step.5.* =====

  // ===== BEGIN step.6.* — Espacio de trabajo del Sexto Paso =====
  // Encabezados de la lista
  'step.6.defects.copy_from_step5': 'Copiar del Quinto Paso',
  'step.6.defects.copy_from_step5_title': 'Copiar los defectos de carácter del Paso 5',
  'step.6.defects.list_title': 'Mis defectos de carácter',
  'step.6.defects.counts': '({total} en total, {completed} completados)',
  'step.6.defects.click_for_details': 'haz clic para ver/agregar detalles',
  'step.6.defects.click_to_add': 'haz clic para agregar',
  'step.6.defects.add_first': 'Agrega un defecto de carácter…',
  'step.6.defects.add_another': 'Agrega otro defecto de carácter…',
  'step.6.defects.delete': 'Eliminar',
  'step.6.defects.save_failed_badge': '⚠ No se pudo guardar',

  // Campos del formulario de defectos
  'step.6.field.name.label': 'Defecto de carácter / rasgo:',
  'step.6.field.name.placeholder': 'Escribe el nombre del defecto de carácter…',
  'step.6.field.name.help_title': 'Obtener ayuda con los defectos de carácter',
  'step.6.question.1.label': '1. ¿Cómo me perjudica este rasgo?',
  'step.6.question.1.placeholder':
    'Describe cómo este defecto de carácter afecta negativamente tu vida…',
  'step.6.question.2.label': '2. ¿Cómo me sirve o me ayuda este rasgo?',
  'step.6.question.2.placeholder':
    'Describe cómo este defecto de carácter podría servirte o protegerte…',
  'step.6.question.3.label': '3. ¿Cómo sería mi vida con menos de este rasgo?',
  'step.6.question.3.placeholder':
    'Imagina y describe cómo sería tu vida con menos de este rasgo…',
  'step.6.help.defects_title': 'Defectos de carácter / rasgos',

  // Diálogos
  'step.6.dialog.duplicate_name': 'Este defecto de carácter ya está en tu lista.',
  'step.6.dialog.save_warning':
    'Advertencia: no se pudieron guardar tus cambios. Intenta editar de nuevo o revisa tu conexión.',
  'step.6.dialog.delete_confirm':
    '¿Seguro que quieres eliminar «{defect}»? Se perderán todas las respuestas de este defecto de carácter.',
  'step.6.dialog.copy_already_have':
    'Ya ingresaste defectos de carácter en el Paso 6. Para copiar del Paso 5, primero tendrás que eliminar las entradas que ya tienes.',
  'step.6.dialog.copy_none_found':
    'No se encontraron defectos de carácter en el Paso 5. Puedes completar primero el Paso 5 o escribir tus defectos de carácter directamente aquí, en el Paso 6.',
  'step.6.dialog.copy_success':
    'Se copiaron correctamente {count} defecto(s) de carácter del Paso 5. Ahora responde las tres preguntas de cada uno.',
  'step.6.dialog.copy_failed': 'No se pudo copiar del Paso 5. Inténtalo de nuevo.',
  'step.6.dialog.incomplete_answers':
    'Responde las tres preguntas de cada defecto de carácter antes de marcar esta acción como completada.',
  // ===== END step.6.* =====

  // ===== BEGIN step.7.* — Espacio de trabajo del Séptimo Paso =====
  'step.7.prayer.traditional_heading':
    'Oración del Séptimo Paso (de Alcohólicos Anónimos, página 76)',
  'step.7.prayer.traditional_text':
    'Creador mío, ahora estoy dispuesto a que me tengas por completo, con lo bueno y con lo malo. Te ruego que ahora quites de mí cada uno de los defectos de carácter que estorban mi utilidad para ti y para mis semejantes. Concédeme fortaleza al salir de aquí para cumplir tu voluntad. Amén',
  'step.7.prayer.traditional_source': 'Libro Grande de AA, página 76',
  'step.7.prayer.own_words_label': 'Oración del Séptimo Paso en mis propias palabras',
  'step.7.prayer.own_words_placeholder':
    'Escribe aquí tu propia versión de la Oración del Séptimo Paso…',
  // ===== END step.7.* =====

  // ===== BEGIN step.8.list.* — Lista del Octavo Paso =====
  // Ventana modal
  'step.8.list.modal_title': 'Octavo Paso: lista de personas a las que dañé',
  'step.8.list.close': 'Cerrar',
  'step.8.list.login_prompt':
    'Inicia sesión para crear y administrar tu lista del Octavo Paso.',
  'step.8.list.loading': 'Cargando tu lista…',
  'step.8.list.description':
    'Haz una lista de todas las personas a las que hiciste daño. Tu inventario del Cuarto Paso puede ayudarte a crear esta lista.',
  'step.8.list.add_to_list': 'Agregar a la lista',
  'step.8.list.empty':
    'Tu lista está vacía. Comienza agregando personas a las que hiciste daño.',
  'step.8.list.your_list': 'Tu lista',
  'step.8.list.counts': '({total} en total, {completed} completadas)',
  'step.8.list.click_for_details': 'haz clic para ver/agregar detalles',
  'step.8.list.delete': 'Eliminar',
  'step.8.list.save_failed_badge': '⚠ No se pudo guardar',

  // Campos
  'step.8.list.name_label': 'Nombre de la persona',
  'step.8.list.name_placeholder': 'Nombre de la persona',
  'step.8.list.note_label': 'Cómo le hice daño',
  'step.8.list.note_placeholder': 'Nota breve sobre cómo le hice daño',
  'step.8.list.timing_label': 'Momento',
  'step.8.list.form_label': 'Forma',
  'step.8.list.select_placeholder': 'Selecciona…',
  'step.8.list.help_field_title': 'Obtener ayuda con este campo',
  'step.8.list.help_not_found': 'No se encontró contenido de ayuda para este campo.',

  // Opciones de momento (los valores guardados quedan en inglés)
  'step.8.list.timing.ready_now': 'Listo ahora',
  'step.8.list.timing.soon': 'Pronto',
  'step.8.list.timing.future': 'En el futuro',
  'step.8.list.timing.never': 'Nunca',

  // Opciones de forma (los valores guardados quedan en inglés)
  'step.8.list.form.in_person': 'En persona',
  'step.8.list.form.phone_zoom': 'Teléfono/Zoom',
  'step.8.list.form.email_letter': 'Correo electrónico/carta',
  'step.8.list.form.unsent_letter': 'Carta sin enviar',

  // Diálogos
  'step.8.list.dialog.ok': 'Aceptar',
  'step.8.list.dialog.enter_name': 'Escribe un nombre.',
  'step.8.list.dialog.delete_confirm':
    '¿Seguro que quieres quitar a «{name}» de tu lista?',
  'step.8.list.dialog.session_expired_title': 'Sesión expirada',
  'step.8.list.dialog.session_expired_message':
    'Tu sesión expiró. Cierra sesión y vuelve a iniciarla para seguir guardando los cambios.',
  'step.8.list.dialog.save_warning':
    'Advertencia: no se pudieron guardar tus cambios. Intenta editar de nuevo o revisa tu conexión.',
  'step.8.list.dialog.close_unsaved':
    'No se pudieron guardar tus cambios. Si cierras ahora, perderás tu trabajo reciente. ¿Quieres intentarlo de nuevo o cerrar de todos modos?',
  'step.8.list.dialog.close_anyway': 'Cerrar de todos modos',
  'step.8.list.dialog.try_again': 'Intentar de nuevo',
  // ===== END step.8.list.* =====

  // ===== BEGIN step.9.list.* — Step Nine amends list modal =====
  'step.9.list.modal_title': 'Paso Nueve: Hacer enmiendas',
  'step.9.list.close': 'Cerrar',
  'step.9.list.login_prompt':
    'Inicia sesión para crear y gestionar tu lista de enmiendas del Paso Nueve.',
  'step.9.list.loading': 'Cargando tu lista...',
  'step.9.list.description':
    'Haz enmiendas directas a las personas a quienes hiciste daño. Puedes copiar tu lista del Paso 8 o añadir personas directamente aquí.',
  'step.9.list.copy_from_step8': 'Copiar del Paso Ocho',
  'step.9.list.copy_from_step8_title': 'Copiar personas del Paso 8',
  'step.9.list.add_to_list': 'Añadir a la lista',
  'step.9.list.empty': 'Tu lista está vacía. Copia del Paso 8 o añade personas directamente.',
  'step.9.list.your_list': 'Mi lista de enmiendas',
  'step.9.list.counts': '({total} en total, {planned} planificadas, {completed} completadas)',
  'step.9.list.click_for_details': 'haz clic para ver o añadir detalles',
  'step.9.list.delete': 'Eliminar',
  'step.9.list.save_failed_badge': '⚠ Error al guardar',

  'step.9.list.name_label': 'Nombre de la persona',
  'step.9.list.name_placeholder': 'Nombre de la persona',
  'step.9.list.note_label': 'Cómo le hice daño',
  'step.9.list.note_placeholder': 'Nota breve sobre cómo le hice daño',
  'step.9.list.timing_label': 'Momento',
  'step.9.list.form_label': 'Forma',
  'step.9.list.select_placeholder': 'Selecciona...',
  'step.9.list.amends_plan_label': 'Plan de enmienda',
  'step.9.list.amends_plan_placeholder':
    'Qué quiero incluir en esta enmienda y cómo quiero acercarme (en persona, por teléfono o en línea), etc.',
  'step.9.list.amends_completed_label': 'Enmienda completada',
  'step.9.list.amends_completed_hint':
    'Marca esta casilla cuando hayas completado tu enmienda a esta persona y se lo hayas contado a tu padrino.',
  'step.9.list.amends_experience_label': 'Experiencia de la enmienda',
  'step.9.list.amends_experience_placeholder': 'Anota cómo fue, cómo me siento, etc.',
  'step.9.list.help_field_title': 'Obtener ayuda con este campo',
  'step.9.list.help_dialog_title': 'Ayuda',
  'step.9.list.help_not_found': 'No se encontró contenido de ayuda para este campo.',
  'step.9.list.help_error': 'Error al cargar el contenido de ayuda.',

  'step.9.list.timing.ready_now': 'Listo ahora',
  'step.9.list.timing.soon': 'Pronto',
  'step.9.list.timing.future': 'En el futuro',
  'step.9.list.timing.never': 'Nunca',

  'step.9.list.form.in_person': 'En persona',
  'step.9.list.form.phone_zoom': 'Teléfono/Zoom',
  'step.9.list.form.email_letter': 'Correo electrónico/Carta',
  'step.9.list.form.unsent_letter': 'Carta sin enviar',

  'step.9.list.dialog.ok': 'Aceptar',
  'step.9.list.dialog.enter_name': 'Introduce un nombre.',
  'step.9.list.dialog.delete_confirm': '¿Seguro que quieres eliminar a «{name}» de tu lista?',
  'step.9.list.dialog.copy_existing_entries':
    'Ya has añadido personas en el Paso 9. Para copiar del Paso 8, primero debes eliminar tus entradas existentes.',
  'step.9.list.dialog.copy_none_found':
    'No se encontraron personas en el Paso 8. Puedes completar el Paso 8 primero o introducir las personas directamente aquí, en el Paso 9.',
  'step.9.list.dialog.copy_success':
    'Se copiaron {count} persona(s) del Paso 8. Ahora añade tu plan de enmienda y trabaja en hacer tus enmiendas.',
  'step.9.list.dialog.copy_failed': 'No se pudo copiar del Paso 8. Inténtalo de nuevo.',
  'step.9.list.dialog.session_expired_title': 'Sesión expirada',
  'step.9.list.dialog.session_expired_message':
    'Tu sesión ha expirado. Cierra la sesión y vuelve a iniciarla para seguir guardando tus cambios.',
  'step.9.list.dialog.save_warning':
    'Advertencia: no se pudieron guardar tus cambios. Intenta editar de nuevo o revisa tu conexión.',
  'step.9.list.dialog.close_unsaved':
    'No se pudieron guardar tus cambios. Si cierras ahora, perderás tu trabajo reciente. ¿Quieres intentarlo de nuevo o cerrar de todos modos?',
  'step.9.list.dialog.close_anyway': 'Cerrar de todos modos',
  'step.9.list.dialog.try_again': 'Intentar de nuevo',
  // ===== END step.9.list.* =====

  // ===== BEGIN step.10.inventory.* — Step Ten nightly inventory modal =====
  'step.10.inventory.modal_title': 'Paso Diez: Práctica del inventario diario',
  'step.10.inventory.close': 'Cerrar',
  'step.10.inventory.login_prompt': 'Inicia sesión para practicar tu inventario diario.',
  'step.10.inventory.loading': 'Cargando tus entradas de inventario...',
  'step.10.inventory.description':
    'Practica hacer un inventario nocturno. Puedes añadir entradas para tantos días como quieras. Cada entrada debe incluir una fecha y notas breves sobre tu día. Completa 5 entradas para terminar esta acción.',
  'step.10.inventory.add_entry': '+ Añadir entrada',
  'step.10.inventory.add_entry_title': 'Añadir una nueva entrada de inventario',
  'step.10.inventory.empty':
    'Aún no hay entradas de inventario. Haz clic en «Añadir entrada» para empezar.',
  'step.10.inventory.your_list': 'Mis inventarios diarios/nocturnos',
  'step.10.inventory.counts': '({count} {entryWord}, {complete} de {required} completas)',
  'step.10.inventory.no_date': 'Sin fecha',
  'step.10.inventory.click_for_details': 'haz clic para ver o añadir detalles',
  'step.10.inventory.delete': 'Eliminar',
  'step.10.inventory.save_failed_badge': '⚠ Error al guardar',

  'step.10.inventory.date_label': 'Fecha',
  'step.10.inventory.note_label': 'Repaso de mi día',
  'step.10.inventory.note_placeholder':
    '¿Fui resentido, egoísta, deshonesto o temeroso? ¿Debo una disculpa? ¿Necesito hablar de algo con mi padrino? ¿Fui amable, cariñoso y paciente con los demás? ¿Cómo practiqué la recuperación hoy?',

  'step.10.inventory.dialog.ok': 'Aceptar',
  'step.10.inventory.dialog.date_taken':
    'Ya existe una entrada para esta fecha. Elige una fecha diferente.',
  'step.10.inventory.dialog.future_date': 'No puedes seleccionar una fecha futura.',
  'step.10.inventory.dialog.delete_confirm':
    '¿Seguro que quieres eliminar la entrada de inventario del {date}?',
  'step.10.inventory.dialog.delete_confirm_fallback': 'esta entrada',
  'step.10.inventory.dialog.session_expired_title': 'Sesión expirada',
  'step.10.inventory.dialog.session_expired_message':
    'Tu sesión ha expirado. Cierra la sesión y vuelve a iniciarla para seguir guardando tus cambios.',
  'step.10.inventory.dialog.save_warning':
    'Advertencia: no se pudieron guardar tus cambios. Intenta editar de nuevo o revisa tu conexión.',
  'step.10.inventory.dialog.close_unsaved':
    'No se pudieron guardar tus cambios. Si cierras ahora, perderás tu trabajo reciente. ¿Quieres intentarlo de nuevo o cerrar de todos modos?',
  'step.10.inventory.dialog.close_anyway': 'Cerrar de todos modos',
  'step.10.inventory.dialog.try_again': 'Intentar de nuevo',
  // ===== END step.10.inventory.* =====

  // ===== BEGIN step.11.* — Step Eleven quiet time plan =====
  'step.11.plan.label': 'Mi plan para el tiempo diario de silencio',
  'step.11.plan.placeholder':
    'Escribe tu plan para establecer o continuar una práctica diaria de tiempo en silencio...',
  'step.11.plan.practiced_label': 'He practicado mi plan durante 3 días o más',
  // ===== END step.11.* =====

  // ===== BEGIN step.12.* — Step Twelve service plan =====
  'step.12.plan.label': 'Mi plan de servicio y de llevar el mensaje',
  'step.12.plan.placeholder':
    'Escribe tu plan de servicio y de llevar el mensaje a otras personas...',
  // ===== END step.12.* =====

  // ===== BEGIN step.login_prompt.* — shared step page login prompt =====
  'step.login_prompt.body':
    'Inicia sesión si ya tienes una cuenta, o crea una cuenta para registrar tu progreso.',
  'step.login_prompt.sign_in': 'Iniciar sesión',
  'step.login_prompt.create_account': 'Crear cuenta',
  // ===== END step.login_prompt.* =====

  // ===== BEGIN step.share.* — shared sponsor share dialog chrome =====
  'step.share.title': 'Comparte tu trabajo con tu padrino',
  'step.share.close': 'Cerrar',
  'step.share.empty_default': 'Todavía no hay nada que compartir en este paso.',
  'step.share.generating': 'Preparando tu resumen...',
  'step.share.generating_subtext': 'Esto puede tardar un momento.',
  'step.share.ready': 'Tu progreso del trabajo de pasos está listo para compartir.',
  'step.share.view_button': 'Ver el progreso del trabajo de pasos',
  'step.share.options_title': '¿Cómo quieres compartirlo?',
  'step.share.options_hint_in_app':
    'El enlace se puede copiar de inmediato. Ver e Imprimir se abren aquí: toca Listo cuando termines.',
  'step.share.options_hint_window':
    'El enlace se puede copiar de inmediato. Correo electrónico e Imprimir abren más opciones primero.',
  'step.share.copy_link': 'Copiar enlace',
  'step.share.copied': '¡Copiado!',
  'step.share.email': 'Correo electrónico',
  'step.share.email_hint': 'Elige el destinatario y envía',
  'step.share.print': 'Imprimir',
  'step.share.print_hint_in_app': 'Se abre aquí; toca Listo para volver',
  'step.share.print_hint_window': 'Abre la vista previa; usa el diálogo de impresión',
  'step.share.email_form_title': 'Enviar por correo electrónico',
  'step.share.email_to_sponsor': 'Enviar a tu padrino:',
  'step.share.select_sponsor': 'Selecciona un padrino',
  'step.share.email_to_other': 'Enviar a otro correo electrónico:',
  'step.share.email_placeholder': 'correo@ejemplo.com',
  'step.share.email_invalid': 'Introduce una dirección de correo electrónico válida',
  'step.share.email_to_self': 'Enviármelo a mí: ver cómo se ve el correo',
  'step.share.copied_note':
    'Recibirás una copia de este correo. Tu padrino verá que recibiste una copia, y su respuesta te llegará a ti.',
  'step.share.cancel': 'Cancelar',
  'step.share.send_email': 'Enviar correo',
  'step.share.sending': 'Enviando...',
  'step.share.expiry_note':
    'Por privacidad, este enlace de resumen de vista previa expira 7 días después de su creación ({date}).',
  'step.share.error_generating': 'Error al crear el resumen. Inténtalo de nuevo.',
  'step.share.popup_blocked':
    'Permite las ventanas emergentes para ver o imprimir el resumen.',
  'step.share.print_failed':
    'No se pudo abrir el diálogo de impresión. Inténtalo de nuevo o usa Copiar enlace.',
  'step.share.copy_failed': 'No se pudo copiar el enlace. Inténtalo de nuevo.',
  'step.share.email_sent_self': '¡Correo de vista previa enviado a {email}!',
  'step.share.email_sent': '¡Enviado correctamente a {email}!',
  'step.share.email_failed': 'No se pudo enviar el correo. Inténtalo de nuevo.',
  'step.share.preview_done': 'Listo',
  'step.share.preview_title': 'Progreso del trabajo de pasos',
  'step.share.preview_aria': 'Vista previa del progreso del trabajo de pasos',
  'step.share.preview_hint': 'Toca Listo para volver a las opciones de compartir.',
  'step.share.preview_back': '← Volver a Recovery Commons',
  'step.share.preview_close_tab': 'Cierra esta pestaña cuando termines',
  // ===== END step.share.* =====

  // ===== Header menu & footer =====
  'ui.initializing': 'Iniciando...',
  'nav.menu.title': 'Menú',
  'nav.menu.toggle_aria': 'Abrir o cerrar el menú',
  'nav.menu.profile': 'Perfil',
  'nav.menu.invite': 'Invitar',
  'nav.menu.feedback': 'Comentarios',
  'nav.menu.help': 'Ayuda',
  'nav.menu.start_over': 'Guardar y empezar de nuevo',
  'nav.menu.backup': 'Copia de seguridad y restauración',
  'nav.menu.about': 'Acerca de',
  'nav.menu.privacy': 'Privacidad',
  'nav.menu.sign_out': 'Cerrar sesión',
  'nav.sign_in_create': 'Iniciar sesión / Crear cuenta',
  'nav.sign_in': 'Iniciar sesión',
  'nav.workshop': 'Taller',
  'nav.privacy_title': 'Tu privacidad es importante',
  'nav.footer.feedback': 'Comentarios',
  'nav.footer.about': 'Acerca de',
  'nav.footer.privacy': 'Política de privacidad',
  'nav.footer.version': 'Versión {version}',
  'nav.footer.rights': 'Todos los derechos reservados',

  // ===== Sign in, create account, password reset =====
  'auth.form.sign_in_title': 'Iniciar sesión',
  'auth.form.create_title': 'Crear cuenta',
  'auth.form.reset_title': 'Restablecer contraseña',
  'auth.form.close': 'Cerrar',
  'auth.form.email': 'Correo electrónico',
  'auth.form.password': 'Contraseña',
  'auth.form.confirm_password': 'Confirmar contraseña',
  'auth.form.show_password': 'Mostrar contraseña',
  'auth.form.hide_password': 'Ocultar contraseña',
  'auth.form.remember_email': 'Recordar mi correo',
  'auth.form.processing': 'Procesando...',
  'auth.form.send_reset_code': 'Enviar código',
  'auth.form.create_button': 'Crear cuenta',
  'auth.form.sign_in_button': 'Iniciar sesión',
  'auth.form.back_to_sign_in': 'Volver a iniciar sesión',
  'auth.form.have_account': '¿Ya tienes una cuenta? Inicia sesión',
  'auth.form.need_account': '¿No tienes cuenta? Crea una',
  'auth.form.forgot_password': '¿Olvidaste tu contraseña?',
  'auth.form.passwords_mismatch': 'Las contraseñas no coinciden',
  'auth.form.created_signin_failed':
    'Se creó la cuenta, pero no se pudo iniciar sesión. Intenta iniciar sesión manualmente.',
  'auth.form.failed': 'No se pudo iniciar sesión',
  'auth.invite.banner': '{name} te invitó a unirte a Recovery Commons',
  'auth.invite.banner_as_sponsor': '{name} te invitó a unirte a Recovery Commons como su padrino',
  'auth.invite.banner_as_sponsee': '{name} te invitó a unirte a Recovery Commons como su ahijado',
  'auth.display_name.label': 'Nombre visible (nombre e inicial del apellido)',
  'auth.display_name.placeholder': 'p. ej., Juan D',
  'auth.display_name.hint':
    'Cómo te ven otros miembros: solo tu nombre y la inicial de tu apellido (p. ej., Juan D).',
  'auth.reset.title': 'Restablece tu contraseña',
  'auth.reset.code_sent_to': 'Enviamos un código para restablecer la contraseña a:',
  'auth.reset.check_email': 'Revisa tu correo e ingresa abajo el código de 6 dígitos.',
  'auth.reset.code_label': 'Código',
  'auth.reset.code_placeholder': 'Código de 6 dígitos',
  'auth.reset.new_password': 'Nueva contraseña',
  'auth.reset.new_password_placeholder': 'Escribe la nueva contraseña',
  'auth.reset.password_min': 'La contraseña debe tener al menos 8 caracteres',
  'auth.reset.confirm_new_password': 'Confirmar nueva contraseña',
  'auth.reset.confirm_new_password_placeholder': 'Confirma la nueva contraseña',
  'auth.reset.resetting': 'Restableciendo contraseña...',
  'auth.reset.submit': 'Restablecer contraseña',
  'auth.reset.success': '¡Contraseña restablecida! Ya puedes iniciar sesión con tu nueva contraseña.',
  'auth.reset.failed': 'No se pudo restablecer la contraseña',

  // ===== Home page =====
  'home.tagline': 'Trabaja tus pasos. Apoya tu recuperación. Dale a tu reunión una página de inicio.',
  'home.section_heading': 'Lo que encontrarás aquí',
  'home.bullet1':
    'Un lugar para llevar el registro de tu trabajo de los 12 pasos con acciones guiadas, videos y un progreso que es tuyo, para que no pierdas el impulso.',
  'home.bullet2': 'La página de inicio de nuestro Taller actual de los 12 Pasos de SAA',
  'home.bullet3':
    'Privacidad y control: tu trabajo de los pasos está cifrado y solo tú lo ves; tú y tu reunión deciden quién ve la información de la reunión.',
  'home.saa_subtitle': 'Adictos al Sexo Anónimos',
  'home.open_saa_hint':
    'Abre SAA para trabajar tus pasos. Usa el enlace Taller en el encabezado para conocer el taller de pasos 2026.',
  'home.more_programs': 'Más programas (p. ej., AA) próximamente.',

  // ===== Verify email page =====
  'auth.verify.title': 'Verifica tu correo electrónico',
  'auth.verify.sent_to': 'Enviamos un código de verificación a:',
  'auth.verify.check_email': 'Revisa tu correo (incluida la carpeta de spam o correo no deseado)',
  'auth.verify.from_label': 'El correo viene de',
  'auth.verify.spam_hint': 'Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam o correo no deseado.',
  'auth.verify.code_label': 'Código de verificación',
  'auth.verify.code_placeholder': 'Ingresa el código de 6 dígitos de tu correo',
  'auth.verify.verifying': 'Verificando...',
  'auth.verify.submit': 'Verificar correo',
  'auth.verify.no_code': '¿No recibiste el código?',
  'auth.verify.resend': 'Reenviar código de verificación',
  'auth.verify.resend_short': 'Reenviar código',
  'auth.verify.resent': '¡Código reenviado! Revisa tu correo.',
  'auth.verify.code_required': 'Se requieren el código de verificación y el correo electrónico',
  'auth.verify.email_required': 'Se requiere el correo electrónico',
  'auth.verify.verified_sign_in': '¡Correo verificado! Ya puedes iniciar sesión en tu cuenta.',
  'auth.verify.verified_logged_in': '¡Correo verificado! Ya iniciaste sesión.',
  'auth.verify.success_title': '¡Correo verificado y sesión iniciada!',
  'auth.verify.success_body': 'Tu correo se verificó correctamente y ya iniciaste sesión. Redirigiendo…',
  'auth.verify.continue': 'Continuar',
  'auth.verify.failed_title': 'La verificación falló',
  'auth.verify.go_to_sign_in': 'Ir a iniciar sesión',

  // ===== Sign-in / account server messages =====
  'auth.server.network_error': 'Error de red. Inténtalo de nuevo.',
  'auth.server.invalid_email': 'El formato del correo electrónico no es válido',
  'auth.server.user_exists': 'Ya existe una cuenta con este correo electrónico.',
  'auth.server.send_failed': 'No se pudo enviar el correo de verificación',
  'auth.server.create_failed': 'No se pudo crear la cuenta',
  'auth.server.created_can_log_in': 'Cuenta creada. Ya puedes iniciar sesión.',
  'auth.server.created_check_email': 'Cuenta creada. Revisa tu correo para verificarla.',
  'auth.server.user_not_found': 'No se encontró el usuario',
  'auth.server.already_verified': 'El correo ya está verificado',
  'auth.server.invalid_code': 'El código de verificación no es válido',
  'auth.server.code_expired': 'El código de verificación venció. Solicita uno nuevo.',
  'auth.server.verify_failed': 'La verificación falló',
  'auth.server.verified': 'Correo verificado',
  'auth.server.invalid_credentials': 'Correo electrónico o contraseña incorrectos',
  'auth.server.inactive': 'La cuenta no está activa',
  'auth.server.not_verified': 'Tu correo no está verificado. Revisa tu correo para verificarlo.',
  'auth.server.login_failed': 'No se pudo iniciar sesión',
  'auth.server.login_ok': 'Sesión iniciada',
  'auth.server.reset_sent': 'Si existe una cuenta con este correo, se envió un código para restablecer la contraseña.',
  'auth.server.reset_request_failed': 'No se pudo procesar la solicitud para restablecer la contraseña',
  'auth.server.invalid_reset_code': 'El código para restablecer no es válido',
  'auth.server.reset_code_expired': 'El código para restablecer venció. Solicita uno nuevo.',
  'auth.server.reset_ok': 'Contraseña restablecida',
  'auth.server.resend_sent': 'Si existe una cuenta con este correo, se envió un código de confirmación',
  'auth.server.resend_ok': 'Código de confirmación reenviado',
  'auth.server.resend_failed': 'No se pudo reenviar el código de confirmación',

  // ===== Account emails (sent by the server: verification + password reset codes) =====
  // Keep in sync with lambda/email_i18n.py. {name} is the member's name.
  'email.auth.verify.subject': 'Verifica tu cuenta de Recovery Commons',
  'email.auth.reset.subject': 'Código para restablecer tu contraseña',
  'email.auth.greeting': '¡Hola, {name}!',
  'email.auth.greeting_no_name': '¡Hola!',
  'email.auth.verify.instructions': 'Usa el siguiente código para verificar tu correo electrónico:',
  'email.auth.reset.instructions': 'Usa el siguiente código para restablecer tu contraseña:',
  'email.auth.expires': 'Este código vence en 15 minutos.',
  'email.auth.ignore': 'Si no solicitaste esto, ignora este correo.',
  'email.auth.footer': 'Recovery Commons: apoyando tu camino de recuperación',

  // ===== Invitation panel (shown to invited members right after signup) =====
  'auth.invite.panel.title': 'Invitaciones',
  'auth.invite.panel.pending_title': 'Invitaciones pendientes ({count})',
  'auth.invite.panel.loading': 'Cargando invitaciones...',
  'auth.invite.panel.empty': 'No tienes invitaciones pendientes',
  'auth.invite.panel.load_failed': 'No se pudieron cargar las invitaciones',
  'auth.invite.panel.accept_failed': 'No se pudo aceptar la invitación',
  'auth.invite.panel.decline_failed': 'No se pudo rechazar la invitación',
  'auth.invite.panel.as_sponsor': '{name} te invitó a ser su padrino',
  'auth.invite.panel.as_sponsee': '{name} te invitó a ser su ahijado',
  'auth.invite.panel.as_friend': '{name} te invitó a conectar como amigo de recuperación',
  'auth.invite.panel.personal_message': 'Mensaje personal:',
  'auth.invite.panel.program': 'Programa:',
  'auth.invite.panel.decline': 'Rechazar',
  'auth.invite.panel.declining': 'Rechazando...',
  'auth.invite.panel.accept': 'Aceptar',
  'auth.invite.panel.accepting': 'Aceptando...',

  // ===== Pick your program (after signup) =====
  'onboarding.title': 'Elige tu programa de recuperación principal',
  'onboarding.note': 'Elige el programa de recuperación que mejor se adapte a tus necesidades. Puedes cambiarlo cuando quieras.',
  'onboarding.assessment_title': 'Resultados de tu autoevaluación',
  'onboarding.assessment_note': 'Según tu autoevaluación, te recomendamos empezar con {program}. Puedes cambiarlo más adelante.',
  'onboarding.assessment_note_generic':
    'Según tu autoevaluación, te recomendamos empezar con un programa de recuperación. Puedes cambiarlo más adelante.',
  'onboarding.recommended_programs': 'Programas recomendados:',
  'onboarding.primary': 'Principal',
  'onboarding.recommended': 'Recomendado',
  'onboarding.skip': 'Omitir por ahora',
  'onboarding.notice': 'Aviso',
  'onboarding.ok': 'Aceptar',
  'onboarding.save_failed': 'No se pudo guardar tu programa. Puedes elegirlo más tarde en tu perfil.',
  'onboarding.program.aa': 'AA - Alcohólicos Anónimos',
  'onboarding.program.saa': 'SAA - Adictos al Sexo Anónimos',
  'onboarding.program.na': 'NA - Narcóticos Anónimos',
  'onboarding.program.oa': 'OA - Comedores Compulsivos Anónimos',
  'onboarding.program.ga': 'GA - Jugadores Anónimos',
  'onboarding.program.da': 'DA - Deudores Anónimos',
  'onboarding.program.coda': 'CoDA - Codependientes Anónimos',
  'onboarding.program.ca': 'CA - Cocaína Anónimos',
  'onboarding.program.not_sure': 'Todavía no estoy seguro',

  // ===== Shared dialog buttons & sign out =====
  'dialog.yes': 'Sí',
  'dialog.no': 'No',
  'dialog.ok': 'Aceptar',
  'dialog.cancel': 'Cancelar',
  'dialog.close': 'Cerrar',
  'dialog.save': 'Guardar',
  'dialog.delete': 'Eliminar',
  'dialog.help': 'Ayuda',
  'dialog.close_help': 'Cerrar la ayuda',
  'auth.sign_out.title': 'Cerrando sesión...',
  'auth.sign_out.message': 'Cerraste sesión correctamente. Volviendo a la página de inicio.',
  'auth.callback.session_expired': 'La sesión de inicio expiró. Intenta iniciar sesión de nuevo.',
  'auth.callback.unable_to_complete': 'No se pudo completar el inicio de sesión. Inténtalo de nuevo.',
  'auth.callback.verification_failed': 'No se pudo verificar el inicio de sesión. Inténtalo de nuevo.',
  'auth.callback.auth_failed': 'La autenticación falló. Inténtalo de nuevo.',
  'auth.callback.generic': 'Ocurrió un error al iniciar sesión. Inténtalo de nuevo.',
  'auth.callback.title': 'No pudimos iniciar tu sesión',

  // ===== Step 8 dialog =====
  'step.8.alert.complete_one_person':
    'Completa al menos una entrada de persona (nombre, nota, momento y forma) antes de marcar esta acción como completada.',

  // ===== Profile & sponsors (ProfileModal) =====
  'account.title': 'Perfil',
  'account.tab.profile': 'Perfil',
  'account.tab.sponsorship': 'Apadrinamiento',
  'account.profile.load_failed': 'No se pudieron cargar los datos del perfil',
  'account.profile.update_failed': 'No se pudo actualizar el perfil',
  'account.profile.loading': 'Cargando perfil...',
  'account.profile.saving': 'Guardando...',
  'account.profile.save_changes': 'Guardar cambios',
  'account.profile.edit': 'Editar perfil',
  'account.profile.no_data': 'No hay datos de perfil disponibles',
  'account.field.email': 'Correo electrónico',
  'account.field.phone': 'Teléfono',
  'account.field.phone_placeholder': 'p. ej. (555) 123-4567',
  'account.field.phone_help': 'Se usa para las listas de teléfonos de reuniones y talleres cuando decides participar.',
  'account.field.not_available': 'No disponible',
  'account.field.not_provided': 'Sin especificar',
  'account.field.member_since': 'Miembro desde',
  'account.field.last_sign_in': 'Último inicio de sesión',
  'account.status.confirmed': '✓ Confirmado',
  'account.status.pending': 'Pendiente',
  'account.sponsor.fill_all_fields': 'Por favor completa todos los campos (Programa, Nombre y Correo electrónico).',
  'account.sponsor.invalid_email': 'Por favor ingresa un correo electrónico válido.',
  'account.sponsor.added': '¡Padrino agregado con éxito!',
  'account.sponsor.add_failed': 'No se pudo agregar el padrino. Por favor intenta de nuevo.',
  'account.sponsor.remove_confirm': '¿Seguro que quieres quitar a {name} ({email}) como tu padrino de {program}?',
  'account.sponsor.removed': 'Padrino quitado con éxito.',
  'account.sponsor.remove_failed': 'No se pudo quitar el padrino. Por favor intenta de nuevo.',
  'account.sponsor.section_title': 'Mis padrinos',
  'account.sponsor.section_description': 'Las personas que te apadrinan. Usa Compartir con el padrino en las páginas de los pasos para enviarles resúmenes.',
  'account.sponsor.invite_button': '+ Invitar padrino',
  'account.sponsor.loading': 'Cargando padrinos...',
  'account.sponsor.empty': 'Todavía no has agregado padrinos.',
  'account.sponsor.remove_title': 'Quitar padrino',
  'account.sponsee.remove_confirm': '¿Seguro que quieres quitar a {name} ({email}) como tu ahijado de {program}?',
  'account.sponsee.removed': 'Ahijado quitado con éxito.',
  'account.sponsee.remove_failed': 'No se pudo quitar el ahijado. Por favor intenta de nuevo.',
  'account.sponsee.section_title': 'Mis ahijados',
  'account.sponsee.section_description': 'Las personas que apadrinas. Ellos comparten su progreso contigo usando Compartir con el padrino en sus páginas de los pasos.',
  'account.sponsee.invite_button': '+ Invitar ahijado',
  'account.sponsee.loading': 'Cargando ahijados...',
  'account.sponsee.empty': 'Todavía no has agregado ahijados.',
  'account.sponsee.remove_title': 'Quitar ahijado',

  // ===== Invitations (InviteManagement) =====
  'invite.title': 'Invita a alguien a Recovery Commons',
  'invite.sent_success': '✓ ¡Invitación enviada con éxito!',
  'invite.form.required_fields': 'Por favor completa todos los campos obligatorios',
  'invite.form.send_failed': 'No se pudo enviar la invitación',
  'invite.form.email_label': 'Correo electrónico',
  'invite.form.email_placeholder': 'su.correo@ejemplo.com',
  'invite.form.relationship_label': 'Relación',
  'invite.form.relationship_my_sponsor': 'Mi padrino',
  'invite.form.relationship_my_sponsee': 'Mi ahijado',
  'invite.form.program_label': 'Programa',
  'invite.form.message_label': 'Mensaje personal (opcional)',
  'invite.form.message_placeholder': 'Agrega un mensaje personal a tu invitación...',
  'invite.form.sending': 'Enviando...',
  'invite.form.send': 'Enviar invitación',
  'invite.relationship.sponsor': 'Padrino',
  'invite.relationship.sponsee': 'Ahijado',
  'invite.relationship.friend': 'Amigo en recuperación',
  'invite.status.pending': 'Pendiente',
  'invite.status.accepted': 'Aceptada',
  'invite.status.declined': 'Rechazada',
  'invite.program.ma': 'MA - Marihuana Anónimos',
  'invite.program.aca': 'ACA - Hijos Adultos de Alcohólicos',
  'invite.program.coda': 'CoDA - Codependientes Anónimos',
  'invite.history.title': 'Invitaciones enviadas',
  'invite.history.load_failed': 'No se pudo cargar el historial de invitaciones',
  'invite.history.loading': 'Cargando historial...',
  'invite.history.empty': 'Todavía no has enviado invitaciones. ¡Envía tu primera invitación arriba!',

  // ===== Share & Print dialog =====
  'share.title': 'Compartir e imprimir',
  'share.title_sponsee': 'Progreso actual de {name}',
  'share.subtitle': 'Comparte tu progreso actual',
  'share.subtitle_sponsee': 'Ve y crea informes para tu ahijado ({program})',
  'share.select_title': '¿Qué te gustaría compartir?',
  'share.select_title_sponsee': '¿Qué te gustaría ver?',
  'share.help.title': 'Comparte tu progreso',
  'share.help.title_sponsee': 'Ver el progreso de tu ahijado',
  'share.help.content':
    'Crea un informe para verlo en pantalla, imprimirlo o enviarlo a tu padrino. Por tu privacidad, los informes solo están disponibles durante 7 días.',
  'share.help.content_sponsee':
    'Puedes ver el progreso actual de {name}. Los informes se generan de nuevo cada vez y, por privacidad, solo están disponibles durante 7 días.',
  'share.option.12_step_status.title': 'Estado de los 12 Pasos',
  'share.option.12_step_status.description': 'Tu progreso actual en los 12 pasos',
  'share.option.step_four_inventories.title': 'Inventarios del Paso Cuatro',
  'share.option.step_four_inventories.description': 'Tus 3 inventarios actuales',
  'share.document_name.12_step_status': 'Estado de los 12 Pasos de SAA',
  'share.document_name.step_four_inventories': 'Inventarios del Paso Cuatro',
  'share.generating': 'Generando tu informe...',
  'share.generating_subtext': 'Esto puede tardar un momento.',
  'share.report_ready': '¡Tu informe "{document}" está listo!',
  'share.preview_report': 'Vista previa del informe',
  'share.how_to_share': '¿Cómo te gustaría compartirlo?',
  'share.button.share': 'Compartir',
  'share.button.copy_link': 'Copiar enlace',
  'share.button.copied': '¡Copiado!',
  'share.button.email': 'Correo',
  'share.email.title': 'Enviar por correo electrónico',
  'share.email.to_sponsor': 'Enviar a tu padrino:',
  'share.email.no_sponsors': 'No hay padrinos configurados',
  'share.email.select_sponsor': 'Selecciona un padrino',
  'share.email.to_other': 'Enviar a otro correo:',
  'share.email.placeholder': 'correo@ejemplo.com',
  'share.email.invalid': 'Ingresa un correo electrónico válido',
  'share.email.send': 'Enviar correo',
  'share.email.sending': 'Enviando...',
  'share.back_to_choose': 'Volver para elegir otro informe',
  'share.alert.no_steps':
    'Todavía no hay nada que compartir. Vuelve cuando hayas comenzado a trabajar los 12 pasos de SAA.',
  'share.alert.no_steps_sponsee': '{name} todavía no ha comenzado a trabajar los 12 pasos de SAA.',
  'share.alert.no_inventories':
    'Todavía no hay nada en tus inventarios. Vuelve cuando hayas comenzado a trabajar en tus inventarios del Paso Cuatro.',
  'share.alert.no_inventories_sponsee': '{name} todavía no ha comenzado sus inventarios del Paso Cuatro.',
  'share.alert.create_failed': 'Error al crear el documento. Inténtalo de nuevo.',
  'share.alert.native_share_failed': 'No se pudo compartir. Intenta copiar el enlace.',
  'share.alert.copy_failed': 'No se pudo copiar el enlace. Inténtalo de nuevo.',
  'share.alert.email_sent': '¡Enviado correctamente a {email}!',
  'share.alert.email_failed': 'No se pudo enviar el correo. Inténtalo de nuevo.',

  // ===== Step history (timeline) dialog =====
  'history.title': 'Cronología de {stepTitle}',
  'history.empty':
    'A medida que completes las acciones para trabajar este paso, verás aquí la cronología de tu progreso',
  'history.timeline.started': '{stepTitle} iniciado',
  'history.timeline.completed': '{stepTitle} completado',
  'history.in_progress': 'En progreso',
  'history.edit_button': 'Editar',
  'history.edit_dates_tooltip': 'Editar fechas',
  'history.duration_one': 'Duración: {count} día',
  'history.duration_other': 'Duración: {count} días',
  'history.edit_dates_title': 'Editar fechas del paso',
  'history.start_date_label': 'Fecha de inicio:',
  'history.completed_date_label': 'Fecha de finalización:',
  'history.saving': 'Guardando...',
  'history.alert.start_date_required': 'Ingresa una fecha de inicio',
  'history.alert.start_date_invalid': 'Ingresa una fecha de inicio válida',
  'history.alert.start_date_future': 'La fecha de inicio no puede estar en el futuro',
  'history.alert.completed_date_invalid': 'Ingresa una fecha de finalización válida',
  'history.alert.completed_date_future': 'La fecha de finalización no puede estar en el futuro',
  'history.alert.completed_before_start': 'La fecha de finalización debe ser posterior a la fecha de inicio',
  'history.alert.dates_updated': 'Fechas actualizadas correctamente',
  'history.alert.update_failed': 'No se pudieron actualizar las fechas',

  // ===== Feedback dialog =====
  'feedback.title': 'Formulario de comentarios',
  'feedback.close_aria': 'Cerrar formulario de comentarios',
  'feedback.subtitle': 'Gracias por ayudarnos a mejorar Recovery Commons',
  'feedback.success.title': '¡Gracias!',
  'feedback.success.message': 'Tus comentarios se enviaron correctamente.',
  'feedback.success.copy_emailed': 'Se envió una copia a {email}',
  'feedback.type_label': 'Tipo de comentario:',
  'feedback.type.general': 'General',
  'feedback.type.bug': 'Error / Falla',
  'feedback.type.idea': 'Idea',
  'feedback.type.translation': 'Idioma / Traducción',
  'feedback.text_label': 'Comentarios:',
  'feedback.text_placeholder': 'Comparte tus comentarios...',
  'feedback.text_placeholder_translation':
    'Cuéntanos qué no suena bien y qué sugieres. Copiar las palabras exactas nos ayuda.',
  'feedback.email_copy': 'Enviarme por correo una copia de mis comentarios',
  'feedback.submit': 'Enviar comentarios',
  'feedback.submitting': 'Enviando...',
  'feedback.submit_failed': 'No se pudieron enviar los comentarios',
  'feedback.info.user': 'Usuario:',
  'feedback.info.location': 'Ubicación en la app:',
  'feedback.info.device': 'Dispositivo y navegador:',
  'feedback.info.device_value': '{deviceType} - {browser} {browserVersion} en {os}',

  // ===== About dialog =====
  'about.title': 'Acerca de Recovery Commons',
  'about.load_error': 'No se puede cargar el contenido en este momento.',
  'about.toc_aria': 'Contenido de Acerca de',
  'about.toc_title': 'Contenido',
  'about.version_history': 'Historial de versiones',
  'about.loading_content': 'Cargando contenido...',
  'about.show_earlier_versions': 'Mostrar versiones anteriores',
  'about.show_fewer_versions': 'Mostrar menos versiones',
  'about.deployed': 'Publicado: {date}',
  'about.loading_version': 'Cargando información de la versión...',

  // ===== Video dialog =====
  'video.default_title': 'Guía en video',
  'video.loading': 'Cargando video...',
  'video.iframe_title': 'Video de Recovery Commons',

  // ===== Save & Start over (modal wrapper) =====
  'start_over.title': 'Guardar y empezar de nuevo',

  // ===== Saved copies of step work (StepWorkArchiveTab) =====
  'archive.default_save_name': 'Antes del taller – {date}',
  'archive.summary.no_work': 'Todavía no hay trabajo de los pasos guardado',
  'archive.summary.getting_started_done': 'Primeros pasos completado',
  'archive.summary.getting_started_started': 'Primeros pasos comenzado',
  'archive.summary.steps_completed': '{count} de 12 pasos completados',
  'archive.summary.working_through': 'trabajando los pasos',
  'archive.error.load_failed': 'No pudimos cargar tu trabajo de los pasos. Inténtalo de nuevo.',
  'archive.error.name_required': 'Escribe un nombre para esta copia guardada.',
  'archive.error.save_failed': 'No pudimos guardar tu trabajo. Inténtalo de nuevo.',
  'archive.error.restore_failed': 'No pudimos restaurar. Inténtalo de nuevo.',
  'archive.error.delete_failed': 'No se pudo eliminar.',
  'archive.dialog.nothing_to_save_title': 'Todavía no hay nada que guardar',
  'archive.dialog.nothing_to_save_message':
    'Todavía no tienes trabajo de los pasos en Recovery Commons. Cuando lo tengas, vuelve aquí antes de empezar de nuevo — guardaremos una copia para ti.',
  'archive.dialog.limit_title': 'Llegaste al límite de copias guardadas',
  'archive.dialog.limit_message':
    'Puedes tener hasta {max} copias con nombre. Elimina una de la lista de abajo para guardar otra.',
  'archive.dialog.fresh_start_title': 'Estás listo para un nuevo comienzo',
  'archive.dialog.fresh_start_message':
    'Tu trabajo de los pasos anterior quedó guardado como "{name}". Tus pasos se reiniciaron — ve a Primeros pasos cuando estés listo.',
  'archive.dialog.open_failed_title': 'No pudimos abrir la copia guardada',
  'archive.dialog.open_failed_message': 'Inténtalo de nuevo.',
  'archive.dialog.restore_title': '¿Volver a este trabajo guardado?',
  'archive.dialog.restore_message':
    'Tu trabajo de los pasos actual será reemplazado por "{name}". Si ahora tienes trabajo sin guardar, primero guardaremos una copia automáticamente.',
  'archive.dialog.restore_confirm': 'Cambiar a esta copia',
  'archive.dialog.restored_title': 'Trabajo guardado restaurado',
  'archive.dialog.restored_message': '"{name}" es ahora tu trabajo de los pasos activo.',
  'archive.dialog.delete_title': '¿Eliminar esta copia guardada?',
  'archive.dialog.delete_message': '¿Eliminar "{name}" de forma permanente? Esto no se puede deshacer.',
  'archive.signed_out':
    'Inicia sesión para guardar tu trabajo de los pasos y empezar de nuevo con un espacio limpio.',
  'archive.loading': 'Cargando…',
  'archive.hero.title': '¿Vas a trabajar los pasos otra vez?',
  'archive.hero.lead':
    'Muchas personas regresan para un taller o una nueva vuelta en la recuperación. Si ya tienes trabajo de los pasos en Recovery Commons, guárdalo aquí primero — guardamos una copia para ti y luego reiniciamos tus pasos para que puedas empezar de nuevo.',
  'archive.hero.current_work': 'Tu trabajo de los pasos actual',
  'archive.hero.save_and_start_over': 'Guardar mi trabajo y empezar de nuevo',
  'archive.hero.limit_hint': 'Tienes {max} copias guardadas. Elimina una abajo para guardar otra.',
  'archive.form.name_label': 'Ponle nombre a esta copia guardada',
  'archive.form.name_hint': 'Para que la encuentres después — por ejemplo, “Antes del taller 2026”',
  'archive.form.what_happens_save': 'Guardamos todo lo que has hecho hasta ahora con este nombre',
  'archive.form.what_happens_reset': 'Tus pasos quedan en blanco — listos para una nueva vuelta',
  'archive.form.what_happens_switch_back':
    'Puedes volver a esta copia cuando quieras desde la lista de abajo',
  'archive.form.saving': 'Guardando…',
  'archive.ready.with_archives': 'Tus pasos están en blanco — estás listo para comenzar una nueva vuelta.',
  'archive.ready.no_archives':
    'Tus pasos están en blanco. Cuando tengas trabajo de los pasos que guardar, ven aquí antes de tu próxima vuelta.',
  'archive.ready.go_getting_started': 'Ir a Primeros pasos',
  'archive.list.title': 'Trabajo de los pasos guardado anteriormente',
  'archive.list.intro_active':
    'Cuando empieces de nuevo, tu trabajo anterior aparecerá aquí. Puedes volver a él cuando quieras.',
  'archive.list.intro_ready': 'Vuelve a una vuelta anterior o elimina las copias que ya no necesites.',
  'archive.list.auto_section': 'Copias automáticas',
  'archive.list.auto_tag': 'Guardada automáticamente',
  'archive.list.details': 'Detalles',
  'archive.list.switch': 'Cambiar a esta',
  'archive.list.limit_note': 'Hasta {max} copias con nombre ({count} usadas)',
  'archive.view.default_title': 'Copia guardada',
  'archive.view.saved_meta': 'Guardada {date} · {summary}',
  'archive.view.completed_steps': 'Pasos completados: {steps}',
  'archive.view.inventories_included': 'Inventarios incluidos ({count})',

  // ===== Backup & Restore (legacy BackupRestoreModal) =====
  'backup.title': 'Copia de seguridad y restaurar',
  'backup.eol.title': 'Copia de seguridad y restaurar va a ser reemplazado.',
  'backup.eol.body':
    'Para guardar tu trabajo de los pasos y empezar de nuevo, usa {action} en el menú — guardamos una copia en el servidor para ti.',
  'backup.eol.action': 'Guardar y empezar de nuevo',
  'backup.eol.open_button': 'Abrir Guardar y empezar de nuevo',
  'backup.select_program_track': 'Elige programa y recorrido',
  'backup.more_programs_soon': 'Pronto habrá más programas',
  'backup.choose_action': 'Elige una acción',
  'backup.mobile_tips': 'Consejos para el celular',
  'backup.processing': 'Procesando...',
  'backup.backup.title': 'Hacer copia de seguridad del progreso',
  'backup.backup.intro':
    'Esto hará una copia de seguridad de tu progreso en {label}, incluidos los pasos completados, las entradas de inventario y tus notas personales.',
  'backup.backup.filename_label': 'Nombre del archivo:',
  'backup.backup.filename_placeholder': 'Escribe el nombre del archivo',
  'backup.backup.location_label': 'Elegir ubicación:',
  'backup.backup.location_text':
    'Se te pedirá que elijas una carpeta donde quieras guardar la copia de seguridad.',
  'backup.backup.encryption_label': 'Cifrado:',
  'backup.backup.encryption_text':
    'La copia de seguridad estará cifrada y solo esta aplicación podrá leerla para restaurarla en el futuro.',
  'backup.backup.clear_after': 'Borrar los datos después de la copia de seguridad',
  'backup.backup.error.filename_required': 'Escribe un nombre de archivo',
  'backup.backup.error.check_failed': 'No pudimos revisar tus datos actuales. Inténtalo de nuevo.',
  'backup.backup.completed': 'Copia de seguridad completada',
  'backup.backup.completed_and_cleared':
    'Copia de seguridad completada y datos borrados de la aplicación',
  'backup.backup.completed_clear_failed':
    'Copia de seguridad completada, pero no se pudieron borrar los datos: {error}',
  'backup.backup.failed': 'La copia de seguridad falló',
  'backup.backup.failed_with_reason': 'La copia de seguridad falló: {error}',
  'backup.no_data.title': 'No hay datos para la copia de seguridad',
  'backup.no_data.message':
    'No hay datos para hacer una copia de seguridad. Primero completa algunos pasos o agrega entradas al inventario.',
  'backup.restore.title': 'Restaurar progreso',
  'backup.restore.intro':
    'Esto cargará los datos de progreso de {label} desde un archivo de copia de seguridad.',
  'backup.restore.current_data_warning':
    'Ya tienes progreso y contenido en {label}. Si no quieres que esta importación lo reemplace, elige cancelar y haz una copia de seguridad.',
  'backup.restore.failed': 'No se pudo restaurar',
  'backup.restore.failed_with_reason': 'No se pudo restaurar: {error}',
  'backup.restore.error.overwrite_required':
    'Marca "Reemplazar el progreso existente" para continuar, o primero borra tus datos actuales',
  'backup.restore.error.clear_failed': 'No se pudieron borrar los datos actuales',
  'backup.restore.result.heading': '¡Restauración completada con éxito!',
  'backup.restore.result.heading_cleared': '¡Datos borrados y restauración completada con éxito!',
  'backup.restore.result.restored_one': 'Restaurado con éxito: {count} elemento',
  'backup.restore.result.restored_other': 'Restaurados con éxito: {count} elementos',
  'backup.restore.result.warnings_one': 'Restaurado con advertencias: {count} elemento',
  'backup.restore.result.warnings_other': 'Restaurados con advertencias: {count} elementos',
  'backup.restore.result.skipped_one': 'Omitido: {count} elemento (no se pudo emparejar)',
  'backup.restore.result.skipped_other': 'Omitidos: {count} elementos (no se pudieron emparejar)',
  'backup.restore.completed': 'Restauración completada con éxito',
  'backup.restore.completed_cleared': 'Datos borrados y restaurados con éxito',
  'backup.restore.clear_and_restore_failed': 'No se pudo borrar y restaurar: {error}',
  'backup.preview.title': 'Vista previa de la restauración',
  'backup.preview.file_contents': 'Contenido del archivo:',
  'backup.preview.program': 'Programa:',
  'backup.preview.track': 'Recorrido:',
  'backup.preview.backup_date': 'Fecha de la copia de seguridad:',
  'backup.preview.steps_with_data': 'Pasos con datos:',
  'backup.preview.inventories': 'Inventarios:',
  'backup.preview.unknown': 'Desconocido',
  'backup.preview.none': 'Ninguno',
  'backup.preview.inventories_none': 'No se encontró ninguno',
  'backup.preview.entries_one': '{count} entrada',
  'backup.preview.entries_other': '{count} entradas',
  'backup.preview.entries_across': '{count} entradas en {inventories} inventarios',
  'backup.preview.overwrite_existing': 'Reemplazar el progreso existente',
  'backup.preview.clear_and_restore': 'Borrar y restaurar',
  'backup.preview.restoring': 'Restaurando...',
  'backup.preview.restore_data': 'Restaurar datos',
  'backup.clear.title': 'Borrar progreso',
  'backup.clear.intro':
    'Esto eliminará de forma permanente todos tus datos de progreso de {label}. Esta acción no se puede deshacer.',
  'backup.clear.warning':
    'Tienes datos actuales en {label}. Asegúrate de haber hecho una copia de seguridad primero.',
  'backup.clear.confirm_label': 'Escribe "{word}" para confirmar:',
  'backup.clear.error.confirm_required': 'Escribe "{word}" para confirmar',
  'backup.clear.success': 'Datos borrados con éxito',
  'backup.clear.failed': 'No se pudo borrar',
  'backup.clear.failed_with_reason': 'No se pudo borrar: {error}',
  'backup.clear.clearing': 'Borrando...',
  'backup.clear.clear_all': 'Borrar todos los datos',

  // ===== Relative dates ("2 weeks and 3 days ago") =====
  'time.today': 'hoy',
  'time.yesterday': 'ayer',
  'time.ago': 'hace {duration}',
  'time.and': '{a} y {b}',
  'time.day_one': '{count} día',
  'time.day_other': '{count} días',
  'time.week_one': '{count} semana',
  'time.week_other': '{count} semanas',
  'time.month_one': '{count} mes',
  'time.month_other': '{count} meses',
  'time.year_one': '{count} año',
  'time.year_other': '{count} años',

  // ===== Saved copies list & backup helpers =====
  'archive.summary.snapshot': 'Copia del trabajo de los pasos',
  'archive.summary.getting_started': 'Primeros pasos',
  'archive.summary.steps_completed_one': '{count} paso completado',
  'archive.summary.steps_completed_other': '{count} pasos completados',
  'archive.summary.inventories_saved': 'inventarios guardados',
  'backup.button.backup': 'Copia de seguridad',
  'backup.button.backup_share': 'Copia de seguridad y compartir',
  'backup.button.choose_file': 'Elegir archivo',
  'backup.button.choose_file_restore': 'Elegir archivo para restaurar',
  'backup.tips.mobile_file_manager': 'Usa el administrador de archivos de tu dispositivo para encontrar los archivos exportados',
  'backup.tips.mobile_file_picker': 'Para importar, usa el selector de archivos de tu dispositivo',
  'backup.tips.ios': 'En iOS, los archivos se guardan en la app Archivos',
  'backup.tips.android': 'En Android, los archivos se guardan en la carpeta Descargas',
  'backup.tips.desktop_downloads': 'Los archivos se guardarán en tu carpeta de Descargas',
  'backup.tips.desktop_location': 'Puedes elegir otra ubicación al exportar',

  // ===== SAA home page (top of /saa) =====
  // title, subtitle, tab names and tab header lines mirror the English set in Admin → Programs → SAA.
  'saa_home.title': 'SAA - Adictos al Sexo Anónimos',
  'saa_home.subtitle':
    'Antes de llegar a Adictos al Sexo Anónimos, muchos de nosotros nunca supimos que nuestro problema tenía nombre. Lo único que sabíamos era que no podíamos controlar nuestra conducta sexual. Para nosotros, el sexo era una forma de vida que lo consumía todo. Aunque los detalles de nuestras historias eran distintos, nuestro problema era el mismo: éramos adictos al sexo.',
  'saa_home.read_more': 'leer más',
  'saa_home.show_less': 'mostrar menos',
  'saa_home.loading': 'Cargando…',
  'saa_home.retry': 'Reintentar',
  'saa_home.load_failed': 'No se pudo cargar la configuración de la página. Inténtalo de nuevo más tarde.',
  'saa_home.about.intro': 'Esta página te ofrece todo lo que necesitas para tu camino de recuperación en SAA. Usa las pestañas de abajo para:',
  'saa_home.about.resources_label': 'Videos, artículos, libros y citas',
  'saa_home.about.resources_body':
    'Explorar videos, artículos, libros recomendados y citas de recuperación que te apoyen en tu camino.',
  'saa_home.about.steps_label': 'Trabajar mis pasos',
  'saa_home.about.steps_body':
    'Llevar el registro de tu avance en los 12 pasos de recuperación. Cada paso incluye acciones guiadas, literatura de recuperación y herramientas para ayudarte a trabajar el programa de forma ordenada.',
  'saa_home.about.not_allied':
    'SAA no está afiliado a ninguna secta, religión, partido político, organización ni institución. No deseamos participar en ninguna controversia, y no apoyamos ni nos oponemos a ninguna causa. Nuestro propósito primordial es mantenernos sexualmente sobrios y ayudar a otros adictos al sexo a alcanzar la sobriedad.',
  'saa_home.about.membership':
    'El único requisito para ser miembro es el deseo de dejar la conducta sexual adictiva. En SAA no se pagan cuotas ni honorarios. Nos mantenemos con nuestras propias contribuciones.',
  'saa_home.resources_english_note':
    'Por ahora, los videos, artículos, libros y citas de la pestaña {tab} están en inglés.',
  'saa_home.tab.resources': 'Recursos',
  'saa_home.tab.meetings': 'Reuniones',
  'saa_home.tab.resources_header': 'Explora recursos de recuperación que puedes ver y leer.',
  'saa_home.tab.meetings_header': 'Reuniones y talleres\n(en construcción)',
  'saa_home.loading_resources': 'Cargando recursos…',

  // ===== Resource panels (controls only; resource content stays in English) =====
  'panels.open': 'Abrir',
  'panels.learn_more': 'Más información',
  'panels.no_link': 'No hay enlace disponible',
  'panels.no_video_url': 'No hay URL del video',

  // ===== Document reader window (privacy policy, guides, readings) =====
  'content_reader.loading': 'Cargando...',
  'content_reader.error_title': 'Error',
  'content_reader.load_failed': 'No se pudo cargar el contenido. Inténtalo de nuevo.',
  'content_reader.untitled': 'Sin título',

  // ===== Step help panel (the ? button on step pages, Work my steps tab, Workshop page) =====
  // Use **double asterisks** around in-app control names to show them in bold.
  'step.help.menu.title': 'El menú (☰)',
  'step.help.menu.description': 'Toca el ícono del menú en la esquina superior derecha de cualquier página:',
  'step.help.menu.profile': 'Actualiza tu nombre visible y tu teléfono, y administra tus padrinos en la pestaña Apadrinamiento.',
  'step.help.menu.invite': 'Invita a un padrino, ahijado o amigo a Recovery Commons.',
  'step.help.menu.feedback': 'Envía sugerencias, reporta un problema o haz una pregunta sobre la aplicación.',
  'step.help.menu.help':
    'Cómo funcionan el trabajo de los pasos, compartir y el menú en Recovery Commons: la misma guía que el botón ? en las páginas de los pasos.',
  'step.help.menu.start_over':
    'Archiva tu trabajo de los pasos actual y empieza una nueva vuelta por los pasos. Tu trabajo anterior se guarda en el archivo.',
  'step.help.menu.backup':
    'Exportación o restauración anterior de un archivo de copia de seguridad cifrado en tu dispositivo. La mayoría de las personas usa Guardar y empezar de nuevo.',
  'step.help.menu.about': 'Información sobre Recovery Commons.',
  'step.help.menu.privacy': 'Cómo se protegen tus datos y cómo funciona compartir.',
  'step.help.menu.sign_out': 'Cierra la sesión de tu cuenta.',
  'step.help.work.title': 'Trabajar tus pasos en Recovery Commons',
  'step.help.work.description':
    'Recovery Commons es tu espacio privado para llevar el registro de tu trabajo de los 12 pasos: inventarios, oraciones, planes y avance. Tus datos se guardan automáticamente cuando inicias sesión.',
  'step.help.work.step_open_steps':
    'Desde **SAA**, abre **Trabajar mis pasos** (la pestaña de los 12 Pasos). Empieza con **Primeros pasos** y continúa desde ahí.',
  'step.help.work.step_actions':
    'Cada paso tiene una lista de acciones. Marca **Completado** cuando termines una acción. Las acciones completadas se contraen para que la página sea más fácil de manejar. Algunas acciones incluyen los botones **Leer el Libro Verde**, **Leer la guía** o **Ver video**, o campos donde escribes tu trabajo personal de los pasos: preguntas, inventarios, oraciones, planes y otros.',
  'step.help.work.step_help_button': 'Usa el botón de ayuda **?** en la parte superior de cualquier página de los pasos para volver a abrir esta guía.',
  'step.help.work.step_share':
    'Cuando una acción ofrezca **Compartir con el padrino**, úsala para ver o enviar por correo un resumen de tu avance, para que tú y tu padrino puedan revisar juntos tu trabajo. Agrega el correo de tu padrino en **Perfil** (ver la sección del menú más abajo) para que compartir sea más fácil. Compartir es opcional: puedes marcar la acción cuando hayas hablado de tu trabajo, aunque no envíes nada.',
  'step.help.work.step_field_help':
    'Usa los botones **?** dentro de los formularios cuando necesites ayuda con un campo específico. Puedes desmarcar una acción si la marcaste como completada demasiado pronto. Por privacidad, los enlaces para compartir vencen después de 7 días.',
  'step.help.steps_tab.title': 'La pestaña Trabajar mis pasos',
  'step.help.steps_tab.description':
    'Esta pestaña es tu lista para trabajar los 12 pasos de SAA. Cada tarjeta es un paso: toca una para abrirla y trabajar sus acciones.',
  'step.help.steps_tab.step_start':
    'Empieza con **Primeros pasos** y luego continúa con el **Paso 1** hasta el **Paso 12** a tu propio ritmo.',
  'step.help.steps_tab.step_statuses':
    'Cuando inicias sesión, cada tarjeta muestra una etiqueta de estado: **No iniciado** (todavía no empiezas), **En progreso** (completaste al menos una acción) o **Completado** (todas las acciones de ese paso están hechas).',
  'step.help.steps_tab.step_auto': 'Los estados se actualizan automáticamente mientras trabajas. Abre cualquier paso para seguir donde te quedaste.',
  'step.help.workshop.title': 'La página del Taller',
  'step.help.workshop.description':
    'La pestaña Taller es tu punto de partida para unirte cada semana a la reunión de Zoom de este taller, conectar con el grupo y abrir tu trabajo de los pasos. **Taller** en el encabezado de la página (arriba de la aplicación) te trae de vuelta aquí desde cualquier parte de Recovery Commons.',
  'step.help.workshop.step_zoom':
    '**Únete en vivo · Zoom** muestra el horario semanal de la reunión del taller. Usa **Abrir reunión de Zoom** o **Copiar enlace** para unirte.',
  'step.help.workshop.step_steps':
    '**Trabajar mis pasos** abre tu lista privada de los pasos de SAA. El botón **?** junto a ella abre esta ayuda.',
  'step.help.workshop.step_first_step':
    '**Inscripción para presentar el Primer Paso**: cuando esté abierta, inscríbete en un turno para compartir tu Primer Paso en una sesión del taller.',
  'step.help.workshop.step_participants':
    '**Participantes del taller**: lista de teléfonos y formas de contacto de los miembros que confirmaron su asistencia.',
  'step.help.workshop.step_share_invite': '**Compartir e invitar**: enlace y texto para invitar a otras personas al taller.',
  'step.help.workshop.step_resources':
    '**Recursos del taller**: enlaces que comparten los facilitadores de este taller (miembros confirmados).',
  'step.help.workshop.step_calendar': '**Calendario del taller**: en qué parte del taller vamos y qué sigue.',
  'step.help.workshop.step_preferences':
    '**Mis preferencias para este taller**: lista de teléfonos, lista de correos y disponibilidad para apadrinar (solo visible para los miembros del taller).',
  'step.help.workshop.step_leave':
    '**Salir del taller**: quítate de la lista de participantes o de la lista de interesados. Tu trabajo de los pasos en Recovery Commons no se ve afectado.',
  'step.help.workshop_work.description':
    'Usa Recovery Commons para llevar el registro privado de tu trabajo de los pasos durante el taller. Esto es aparte de la reunión de Zoom del taller: es tu espacio de trabajo personal.',
  'step.help.workshop_work.step_open_steps':
    'Desde la página del taller, haz clic en **Trabajar mis pasos** para abrir **SAA** → **Trabajar mis pasos** (la pestaña de los 12 Pasos). Empieza con **Primeros pasos** y continúa desde ahí.',
  'step.help.workshop_work.step_actions':
    'Cada paso tiene una lista de acciones. Marca **Completado** cuando termines una acción. Tu avance se guarda automáticamente. Algunas acciones incluyen lecturas, guías o campos donde escribes tu trabajo personal de los pasos: preguntas, inventarios, oraciones, planes y otros.',
};
